/// <reference path="../../typings/browser.d.ts" />
/// <reference path="../../customtypings/vis/vis.d.ts" />

namespace Application.Controllers {
    'use strict';

    import TopologyElementType = Models.TopologyElementType;
    import ITopologyElement = Models.ITopologyElement;
    import TopologyElement = Models.TopologyElement;
    import SonNode = Models.SonNode;
    import IFlexEvent = Models.IFlexEvent;
    import ISonLink = Models.ISonLink;
    import ISonPacketmap = Models.ISonPacketmap;
    import ISonLinkStatsToPlot = Models.ISonLinkStatsToPlot;

    export interface IRouteSupportParams {
        type: string;
        id: number;
    }

    interface ISelectOption {
        value: string;
        text: string;
    }

    interface IsonLinkColorCache {
        [key: number]: string;
    }

    interface IPermissions {
        networkNodes: boolean;
        networks: boolean;
        gateways: boolean;
        probes: boolean;
        hotspots: boolean;
        multiblocks: boolean;
        links: boolean;
    }

    export class NetworkMapController {
        public static $name: string = "networkMapController";
        public static $inject: string[] = ["$scope",
                                           "topologyElementService",
                                           "networkNodeService",
                                           'ModalService',
                                           '$location',
                                           '$routeParams',
                                           '$timeout',
                                           'locationChangerService',
                                           'stompService',
                                           'networkNodeTypeService',
                                           'healthService',
                                           '$q',
                                           '$rootScope',
                                           'blockService',
                                           'multiBlockService',
                                           'messageTranslationsService',
                                           '$cookies',
                                           'sonAdapterService',
                                           'alarmsService',
                                           'aclService',
                                           'userService',
                                           'networkService',
                                           'flexCollectorService',
                                           '$interval',
                                           ];

        private static SON_NETWORK_COOKIE: string = 'mapSonExpanded';
        private static SON_ISOLATED_COOKIE: string = 'mapSonIsolated';

        private allTopologyElements: Models.IAllTopologyElements;
        private backendNetworkNodes: Models.INetworkNode[];
        private backendNetworks: Models.INetwork[];
        private backendGateways: Models.IGateway[];
        private backendHotspots: Models.IHotspot[];
        private backendLinks: Models.ILink[];
        private backendProbes: Models.IProbe[];
        private backendMultiblocks: Models.MultiBlock[];
        private nodesNoPos: Models.INetworkNode[];  // store NetworkNode elements without defined position
        private probesNoPos: Models.IProbe[];       // store Probe elements without defined position
        private selectedElement: Models.ITopologyElement | Models.ILink[] | Models.IMultiBlock[];
        private oneClickDone: boolean;
        private keepSidebar: boolean;
        private networkNodeTypes: Models.NetworkNodeType[];
        private backendSonElements: Models.FlexoSONPacketMap = Models.FlexoSONPacketMap.Empty();

        private canCreate: IPermissions = {
            networkNodes: false,
            networks: false,
            gateways: false,
            probes: false,
            hotspots: false,
            multiblocks: false,
            links: false,
        };

        private canAddExisting: IPermissions = {
            networkNodes: false,
            networks: false,
            gateways: false,
            probes: false,
            hotspots: false,
            multiblocks: false,
            links: false,
        };

        private visNetwork: Vis.INetwork;
        private visOptions: Vis.IOptions;
        private visData: Vis.IData;
        private visEvents: Vis.IEvents;
        private visEdgeMode: boolean;
        private visEdgeMultiblockMode: boolean;
        private showIps: boolean;
        private dragStartData: Vis.IProperties;

        private deleteLinkMode: boolean;
        private networkNodesSubscription: Services.IEventSubscription;
        private sonAdapterSubscription: Services.IEventSubscription;
        private alarmsSubscription: Services.IEventSubscription;
        private mags: Models.INetworkNode[];
        private sonIsolated: boolean;

        private searchText: string;
        private searchResults: Models.ITopologySearchResult[] = [];
        private zoomType: string;
        private zoomId: number;

        private packetMap: ISonPacketmap;
        private connectedSourcesPerSwitch: { [id: number]: string[] } = {};
        private connectedDestinationsPerSwitch: { [id: number]: string[] } = {};
        private sonLinkColorCache:  IsonLinkColorCache = {};

        private userIsAdmin: boolean;
        private currentUserId: string | number;
        private packetMapInterval: angular.IPromise<void>;

        constructor(private $scope: ng.IScope,
                    private topologyElementService: Services.TopologyElementService,
                    private networkNodeService: Services.NetworkNodeService,
                    private modalService: ngModal.IModalService,
                    private $location: ng.ILocationService,
                    private routeParams: ng.route.IRouteParamsService,
                    private $timeout: ng.ITimeoutService,
                    private locationChangerService: Services.LocationChangerService,
                    private stompService: Services.StompService,
                    private networkNodeTypeService: Services.NetworkNodeTypeService,
                    private healthService: Services.HealthService,
                    private $q: ng.IQService,
                    private $rootScope: Services.IFlexSettings,
                    private blockService: Services.BlockService,
                    private multiBlockService: Services.MultiBlockService,
                    private messageTranslationsService: Services.MessageTranslationsService,
                    private $cookies: ng.cookies.ICookiesService,
                    private sonAdapterService: Services.SonAdapterService,
                    private alarmsService: Services.AlarmsService,
                    private aclService: Services.AclService,
                    private userService: Services.UserService,
                    private networkService: Services.NetworkService,
                    private flexCollectorService: Services.FlexCollectorService,
                    private $interval: ng.IIntervalService) {

            this.userService.loadCurrentUser().then((user: Models.User) => {
                this.currentUserId = user.id;
                this.userIsAdmin = user.authorities.some((auth: Models.IAuthority) => {
                    return auth.authority === 'ROLE_ADMIN';
                });
                this.getCreationPermissions();
            });

            this.showIps =  $rootScope.settings.showIps;
            this.sonIsolated = false;

            this.zoomType = (routeParams as IRouteSupportParams).type;
            this.zoomId = (routeParams as IRouteSupportParams).id;


            this.packetMapInterval = this.$interval(() => {
                this.loadSonStats();
            }, 5000);

            this.$timeout(() => {
                this.initVis();    
                this.getAndDrawAllTopologyElements(true);
            });

            this.alarmsSubscription = this.stompService.register(Models.ALARMS_COMPONENT, Models.ALL_OPERATIONS,
                (flexEvent: Models.IFlexEvent) => {
                    if (flexEvent.data.name === 'Link_health') {
                        let visEdges: vis.DataSet = this.visData.edges as vis.DataSet;
                        let [link]: ISonLink[] = this.backendSonElements.links.filter((link: ISonLink) => {
                            return 'sonLinks/' + link.id === flexEvent.data.deviceId;
                        });
                        this.setVisSonLink(link, flexEvent, visEdges, false);
                    }
                }
            );
            this.networkNodesSubscription = this.stompService.register(Models.NETWORK_NODES_COMPONENT, Models.ALL_OPERATIONS,
                (flexEvent: Models.IFlexEvent) => {
                    let op: string = flexEvent.operation;
                    let data: {id: number} = flexEvent.data;
                    let id: number;
                    switch (op) {
                        case Models.CREATE_NETWORK_NODE_OPERATION:
                            this.topologyElementService.getNetworkNodeElementById(data.id).then(
                                (nn: Models.INetworkNode) => {
                                    nn.isSonRelated = this.isSonRelatedElement(nn, Models.TopologyElementType.NetworkNode);
                                    this.createTopologyElement(nn);
                                    this.searchByText("");
                                });
                            break;
                        case Models.SAVE_NETWORK_NODE_OPERATION:
                            this.topologyElementService.getNetworkNodeElementById(data.id).then(
                                (nn: Models.INetworkNode) => {
                                    if (nn.workflowMode === Models.WORKFLOW_MODE_MAINTENANCE) {
                                        this.deleteTopologyElement(data.id, TopologyElementType.NetworkNode);
                                    } else {
                                        this.burnishSonInfoForNetworkNodes();
                                        this.updateTopologyElement(nn);
                                        this.loadBlocksForNetworkNode(nn);
                                    }
                                });
                            this.searchByText("");
                            break;
                        case Models.DELETE_NETWORK_NODE_OPERATION:
                            this.deleteTopologyElement(data.id, TopologyElementType.NetworkNode);
                            this.searchByText("");
                            break;
                        case Models.WORKFLOW_CHANGED_OPERATION:
                            let workflowModeKey: string = "workflowMode";
                            if (data[workflowModeKey] === Models.WORKFLOW_MODE_MAINTENANCE) {
                                this.deleteTopologyElement(data.id, TopologyElementType.NetworkNode);
                            }
                            this.searchByText("");
                            break;
                        case Models.CREATE_NETWORK_OPERATION:
                        case Models.SAVE_NETWORK_OPERATION:
                            this.topologyElementService.getNetworkElementById(data.id).then(
                                (n: Models.Network) => {
                                    this.updateTopologyElement(n);
                                });
                            this.searchByText("");
                            break;
                        case Models.DELETE_NETWORK_OPERATION:
                            this.topologyElementService.getNetworkElementById(data.id).then((n: Models.Network) => {
                                this.networkNodeService.getAllEnabledNetworkNodesPromise().then((nodes: Models.NetworkNode[]) => {
                                    nodes.forEach((node: Models.NetworkNode) => {
                                        if (node.isConnectedToNetwork()) {
                                            node.networkInterfaces.forEach((nic: Models.INetworkInterface) => {
                                                if (nic.networkConnectedTo === n) {
                                                    nic.connected = false;
                                                    nic.networkConnectedTo = undefined;
                                                }
                                            });
                                        }
                                    });
                                });
                            });
                            this.deleteTopologyElement(data.id, TopologyElementType.Network);
                            this.searchByText("");
                            break;
                        case Models.CREATE_GATEWAY_OPERATION:
                        case Models.SAVE_GATEWAY_OPERATION:
                            this.topologyElementService.getGatewayElementById(data.id).then(
                                (g: Models.Gateway) => {
                                    this.updateTopologyElement(g);
                                });
                            this.searchByText("");
                            break;
                        case Models.DELETE_GATEWAY_OPERATION:
                            this.deleteTopologyElement(data.id, TopologyElementType.Gateway);
                            this.searchByText("");
                            break;
                        case Models.CREATE_PROBE_OPERATION:
                            this.$q.all([
                                this.topologyElementService.getLinkElements(),
                                this.topologyElementService.getProbeElementById(data.id),
                            ]).then((res: [Models.ILink[], Models.IProbe]) => {
                                this.backendLinks = res[0];
                                this.createTopologyElement(res[1]);
                            });
                            this.searchByText("");
                            break;
                        case Models.SAVE_PROBE_OPERATION:
                            this.$q.all([
                                this.topologyElementService.getLinkElements(),
                                this.topologyElementService.getProbeElementById(data.id),
                            ]).then((res: [Models.ILink[], Models.IProbe]) => {
                                    this.backendLinks = res[0];
                                    this.updateTopologyElement(res[1]);
                            });
                            this.searchByText("");
                            break;
                        case Models.DELETE_PROBE_OPERATION:
                            this.deleteTopologyElement(data.id, TopologyElementType.Probe);
                            this.searchByText("");
                            break;
                        case Models.CREATE_LINK_OPERATION:
                            let createdLinkData: {networkElement: TopologyElement, networkInterface: {id: string}} = flexEvent.data;
                            id = parseInt(createdLinkData.networkInterface.id, 10);
                            this.topologyElementService.getLinkElementById(id).then(
                                (l: Models.Link) => {
                                    this.createTopologyElement(l);
                                });
                            break;
                        case Models.DELETE_LINK_OPERATION:
                            let deleteLinkData: {networkElement: TopologyElement, networkInterface: {id: string}} = flexEvent.data;
                            id = parseInt(deleteLinkData.networkInterface.id, 10);
                            this.deleteTopologyElement(id, TopologyElementType.Link);
                            break;
                        case Models.TOPOLOGY_ELEMENT_PLACED_OPERATION:
                            let element: TopologyElement = flexEvent.data.topologyElement;
                            element.href = this.topologyElementService.convertSimplifiedHrefToHref(flexEvent.data.href);
                            this.updateTopologyElementPosition(element, flexEvent.data.x, flexEvent.data.y);
                            break;
                        default:
                            console.log(`Unknown ${Models.NETWORK_NODES_COMPONENT} event -> ${flexEvent.operation}`);
                    }
            });

            this.sonAdapterSubscription = this.stompService.register(Models.SON_ADAPTER_COMPONENT, Models.ALL_OPERATIONS,
                (flexEvent: Models.IFlexEvent) => {
                    let op: string = flexEvent.operation;
                    // console.log(op);
                    switch (op) {
                        case Models.SON_NODE_CHANGED:
                            if (this.backendSonElements && this.backendSonElements.switches) {
                                this.backendSonElements.switches.forEach((sonSwitch: Models.ISonNode, i: number) => {
                                    if (sonSwitch.id === flexEvent.data.id) {
                                        // FIXME: only setting the status for now!
                                        this.backendSonElements.switches[i].active = (new Models.SonNode(flexEvent.data)).active;
                                    }
                                });
                                this.setVisNodes();
                            }
                            break;
                        case Models.SON_LINK_CHANGED:
                            if (this.backendSonElements && this.backendSonElements.links) {
                                this.backendSonElements.links.forEach((link: ISonLink, i: number) => {
                                    if (link.id === flexEvent.data.id) {
                                        this.backendSonElements.links[i] = new Models.SonLink(flexEvent.data);
                                        const selected: Models.TopologyElement = this.selectedElement as Models.TopologyElement;
                                        if (selected && selected.href && selected.href === this.backendSonElements.links[i].href)
                                            this.selectedElement = this.backendSonElements.links[i] as Models.TopologyElement;
                                        this.setVisSonLink(link, flexEvent, this.visData.edges as vis.DataSet, false);
                                    }
                                });

                            }
                            break;
                        default:
                            console.log(`Unknown ${Models.SON_ADAPTER_COMPONENT} event -> ${flexEvent.operation}`);
                    }
            });

            this.healthService.subscribeOnChangedHealth(this.$scope, (event: angular.IAngularEvent, args: any[]) => { //tslint:disable-line
                if (this.visEdgeMode)
                    return;

                if (args && args.length > 0) {
                    const strId: string = Common.Utils.strIdFromHref(args[0].data.elementId);
                    for (let nn of this.backendNetworkNodes) {
                        if (Common.Utils.strIdFromHref(nn.href) === strId) {
                            this.updateTopologyElement(nn);
                        }
                    }
                    for (let g of this.backendGateways) {
                        if (Common.Utils.strIdFromHref(g.href) === strId) {
                            this.updateTopologyElement(g);
                        }
                    }
                }
            });

            this.$scope.$on("$destroy", () => {
                if (this.networkNodesSubscription)
                    this.stompService.unregister(this.networkNodesSubscription);
                if (this.sonAdapterSubscription)
                    this.stompService.unregister(this.sonAdapterSubscription);
                if (this.alarmsSubscription)
                    this.stompService.unregister(this.alarmsSubscription);

                if (this.visNetwork !== undefined) {
                    this.visNetwork.destroy();
                    this.visNetwork = undefined;
                }
                if (this.packetMapInterval !== undefined) {
                    this.$interval.cancel(this.packetMapInterval);
                }
            });
        }

        public toggleIps(): void {
            this.$rootScope.settings.showIps = !this.showIps;
            this.showIps = this.$rootScope.settings.showIps;
            this.setVisNodes();
            this.setVisEdges();
        }

        public closeSidebar(): void {
            this.keepSidebar = false;
            this.selectedElement = undefined;
        }

        public editTopologyElement(elementType: TopologyElementType): void {
            if (elementType === TopologyElementType.Network) {
                let copy: Models.INetwork = Common.Utils.clone(this.selectedElement) as Models.INetwork;
                this.modalService.showModal({
                    templateUrl: Application.Controllers.NetworkModalController.templateUrl,
                    controller: Application.Controllers.NetworkModalController.$name,
                    inputs: {
                        network: copy,
                    },
                })
                .then((modal: ngModal.IModalObject) => {
                    let networkModalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.NetworkModalController.ID,
                                                    {bgclose: false, modal: false, keyboard: false});
                    networkModalElem.show();
                    modal.close.then((result: Models.TopologyElement) => {
                        networkModalElem.hide();
                        if (result !== undefined) {
                            this.selectedElement = result;
                            this.saveSelectedElementToDB();
                        }
                    });
                });
            } else if (elementType === TopologyElementType.Gateway) {
                let copy: Models.IGateway = Common.Utils.clone(this.selectedElement) as Models.IGateway;
                this.modalService.showModal({
                    templateUrl: Application.Controllers.GatewayModalController.templateUrl,
                    controller: Application.Controllers.GatewayModalController.$name,
                    inputs: {
                        gateway: copy,
                    },
                })
                .then((modal: ngModal.IModalObject) => {
                    let gatewayModalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.GatewayModalController.ID,
                                                    {bgclose: false, modal: false, keyboard: false});
                    gatewayModalElem.show();
                    modal.close.then((result: Models.TopologyElement) => {
                        gatewayModalElem.hide();
                        if (result !== undefined) {
                            this.selectedElement = result;
                            this.saveSelectedElementToDB();
                        }
                    });
                });
            } else if (elementType === TopologyElementType.Hotspot) {
                let copy: Models.IHotspot = Common.Utils.clone(this.selectedElement) as Models.IHotspot;
                this.modalService.showModal({
                    templateUrl: Application.Controllers.HotspotModalController.templateURL,
                    controller: Application.Controllers.HotspotModalController.$name,
                    inputs: {
                        hotspot: copy,
                        locationEditable: true,
                    },
                })
                .then((modal: ngModal.IModalObject) => {
                    let hotspotModalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.HotspotModalController.ID,
                                                    {bgclose: false, modal: false, keyboard: false});
                    hotspotModalElem.show();
                    modal.close.then((result: Models.TopologyElement) => {
                        hotspotModalElem.hide();
                        if (result !== undefined) {
                            this.selectedElement = result;
                            this.saveSelectedElementToDB();
                        }
                    });
                });
            }
        }

        public addTopologyElement(elementType: TopologyElementType, topoElement?: Models.ITopologyElement): void {
            this.edgeMode('none');
            if (elementType === TopologyElementType.NetworkNode && topoElement !== undefined) { // 0
                [topoElement.x, topoElement.y] = this.topologyElementService.initTopologyCoordinate();
                this.topologyElementService.placeTopologyElement(topoElement)
                    .then((t: TopologyElement) => {
                        this.setPermissionsHelper([t], 'networkNodes', [Common.Utils.idFromHref(t.href)]).then(() => {
                            this.searchByText("");
                            this.updateTopologyElementPosition(t, t.x, t.y);
                        });
                    })
                    .catch((reason: ngCustom.IReason) => {
                        this.messageTranslationsService.showPromiseError(reason);
                        this.getAndDrawAllTopologyElements(); // if anything was wrong, better refresh all elements from backend
                    });
            } else if (elementType === TopologyElementType.Network) {
                this.modalService.showModal({
                    templateUrl: Application.Controllers.NetworkModalController.templateUrl,
                    controller: Application.Controllers.NetworkModalController.$name,
                    inputs: { network: undefined },
                })
                .then((modal: ngModal.IModalObject) => {
                    let networkModal: UIkit.ModalElement = UIkit.modal(Application.Controllers.NetworkModalController.ID,
                                                                       {bgclose: false, modal: false, keyboard: false});
                    networkModal.show();
                    modal.close.then((result: Models.TopologyElement) => {
                        networkModal.hide();
                        if (result !== undefined) {
                            this.topologyElementService.createTopologyElement(elementType, result)
                                .then((network: Models.INetwork) => {
                                    this.createTopologyElement(network);
                                })
                                .catch((reason: ngCustom.IReason) => {
                                    this.messageTranslationsService.showPromiseError(reason);
                                    this.getAndDrawAllTopologyElements(); // if anything was wrong, better refresh all elements from backend
                                });
                        }
                    });
                });
            } else if (elementType === TopologyElementType.Gateway) {
                this.modalService.showModal({
                    templateUrl: Application.Controllers.GatewayModalController.templateUrl,
                    controller: Application.Controllers.GatewayModalController.$name,
                    inputs: { gateway: undefined },
                })
                .then((modal: ngModal.IModalObject) => {
                    let gatewayModal: UIkit.ModalElement = UIkit.modal(Application.Controllers.GatewayModalController.ID,
                                                                       {bgclose: false, modal: false, keyboard: false});
                    gatewayModal.show();
                    modal.close.then((result: Models.TopologyElement) => {
                        gatewayModal.hide();
                        if (result !== undefined) {
                            this.topologyElementService.createTopologyElement(elementType, result)
                                .then((gateway: Models.IGateway) => {
                                    this.createTopologyElement(gateway);
                                })
                                .catch((reason: ngCustom.IReason) => {
                                    this.messageTranslationsService.showPromiseError(reason);
                                    this.getAndDrawAllTopologyElements(); // if anything was wrong, better refresh all elements from backend
                                });
                        }
                    });
                });
            } else if (elementType === TopologyElementType.Probe) {
                if (topoElement !== undefined) {
                    [topoElement.x, topoElement.y] = this.topologyElementService.initTopologyCoordinate();
                    this.topologyElementService.placeTopologyElement(topoElement)
                        .then((t: TopologyElement) => {
                            this.updateTopologyElementPosition(t, t.x, t.y);
                        })
                        .catch((reason: ngCustom.IReason) => {
                            this.messageTranslationsService.showPromiseError(reason);
                            this.getAndDrawAllTopologyElements(); // if anything was wrong, better refresh all elements from backend
                        });
                }
            } else if (elementType === TopologyElementType.Hotspot) { // 5
                this.modalService.showModal({
                    templateUrl: Application.Controllers.HotspotModalController.templateURL,
                    controller: Application.Controllers.HotspotModalController.$name,
                    inputs: {
                        hotspot: undefined,
                        locationEditable: true,
                    },
                })
                .then((modal: ngModal.IModalObject) => {
                    let hotspotModalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.HotspotModalController.ID,
                                                                           {bgclose: false, modal: false, keyboard: false});
                    hotspotModalElem.show();
                    modal.close.then((result: Models.TopologyElement) => {
                        hotspotModalElem.hide();
                        if (result !== undefined) {
                            this.topologyElementService.createTopologyElement(elementType, result)
                                .then((hotspot: Models.IHotspot) => {
                                    this.searchByText("");
                                    this.createTopologyElement(hotspot);
                                })
                                .catch((reason: ngCustom.IReason) => {
                                    this.messageTranslationsService.showPromiseError(reason);
                                    this.getAndDrawAllTopologyElements(); // if anything was wrong, better refresh all elements from backend
                                });
                        }
                    });
                });
            }
        }

        public deleteTopologyElementModal(): void {
            if (this.selectedElement && Models.TopologyElement.getElementTypeAsString((this.selectedElement as Models.ITopologyElement))) {
                let isNetworkNode: boolean = Models.TopologyElement
                    .getElementTypeAsString((this.selectedElement as Models.ITopologyElement)) === 'network node';

                this.modalService
                    .showModal({
                        templateUrl: Application.Controllers.ConfirmModalController.templateURL,
                        controller: Application.Controllers.ConfirmModalController.$name,
                        inputs: {
                            title: 'DELETE '
                                   .concat(Models.TopologyElement
                                        .getElementTypeAsString((this.selectedElement as Models.ITopologyElement))
                                    .toUpperCase()),
                            description: isNetworkNode ?
                                "It will be removed from the map but will persist in the network node list."
                                : "This action cannot be undone.",
                            name: (this.selectedElement as Models.ITopologyElement).name,
                            type: 'information',
                        },
                    })
                    .then((modal: ngModal.IModalObject) => {
                        let modalElem: UIkit.ModalElement =
                            UIkit.modal(Application.Controllers.ConfirmModalController.ID,
                                        { bgclose: false, modal: false, keyboard: false });
                        modalElem.show();
                        modal.close.then((result: Object) => {
                            modalElem.hide();
                            if (result) this.deleteTopologyElementFromDB();
                        });
                    });
            } else if (this.selectedElement && (this.selectedElement as Models.ILink[]).length > 0) {
                let linksNo: number = (this.selectedElement as Models.ILink[]).length;
                let msg: string = (linksNo === 1 ? `The link` : `${linksNo} links`) + ' will be removed. This action cannot be undone.';
                this.modalService
                    .showModal({
                        templateUrl: Application.Controllers.ConfirmModalController.templateURL,
                        controller: Application.Controllers.ConfirmModalController.$name,
                        inputs: {
                            title: 'DELETE LINK',
                            description: msg,
                            name: undefined,
                            type: 'warning',
                        },
                    })
                    .then((modal: ngModal.IModalObject) => {
                        let modalElem: UIkit.ModalElement =
                            UIkit.modal(Application.Controllers.ConfirmModalController.ID,
                                        { bgclose: false, modal: false, keyboard: false });
                        modalElem.show();
                        modal.close.then((result: Object) => {
                            modalElem.hide();
                            if (result) this.deleteTopologyElementFromDB();
                        });
                    });
            }
        }

        public launchNodeModal(step?: number): void {
            let node: Models.INetworkNode = (step === -1) ? undefined : this.selectedElement as Models.INetworkNode;
            step = (step === -1) ? undefined : step;
            if (this.networkNodeTypes === undefined) {
                this.networkNodeTypeService.getAllNetworkNodeTypes().then(
                    (nnt: Models.INetworkNodeType[]) => {
                        this.networkNodeTypes = nnt;
                        this.launchNodeModalHelper(node, step);
                    });
            } else {
                this.launchNodeModalHelper(node, step);
            }
        }

        public launchProbeModal(newProbe?: boolean): void {
            let copy: Models.IProbe;
            let title: string;
            if (newProbe === true) {
                copy = Models.Probe.Empty();
                title = "New probe";
            } else {
                copy = Models.Probe.Copy(this.selectedElement as Models.IProbe);
                title = "Edti probe";
            }
            this.modalService.showModal({
                templateUrl: Application.Controllers.ProbeModalController.templateURL,
                controller: Application.Controllers.ProbeModalController.$name,
                inputs: {
                    title: title,
                    probe: copy,
                    networks: this.backendNetworks,
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.ProbeModalController.ID,
                                                    {bgclose: false, modal: false, keyboard: false});
                modalElem.show();
                modal.close.then((result: Models.IProbe) => {
                    modalElem.hide();
                    if (result) {
                        if (!result.x || !result.y) {
                            [result.x, result.y] = this.topologyElementService.initTopologyCoordinate();
                        }
                        this.topologyElementService
                            .saveTopologyElement(result as Models.ITopologyElement)
                            .then((p: Models.ITopologyElement) => {
                                this.topologyElementService.getLinkElements().then(
                                    (links: Models.ILink[]) => {
                                        this.backendLinks = links;
                                        this.updateTopologyElement(p);
                                    });
                            });
                    }
                });
            });
        }

        public launchNetworkConfigModal(): void {
            let copy: Models.ITopologyElement = Common.Utils.clone(this.selectedElement) as Models.ITopologyElement;

            this.modalService.showModal({
                templateUrl: Application.Controllers.NetworkConfigModalController.templateUrl,
                controller: Application.Controllers.NetworkConfigModalController.$name,
                inputs: {
                    element: copy,
                    gateways: this.backendGateways,
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.NetworkConfigModalController.ID,
                                                    {bgclose: false, modal: false, keyboard: false});
                modalElem.show();
                modal.close.then((result: Models.ITopologyElement) => {
                    modalElem.hide();
                    if (result) {
                        this.selectedElement = result;
                        this.saveSelectedElementToDB();
                    }
                });
            });
        }

        public loadJobs(probeHref: string): void {
            this.$location.path("/admin/probes/" + Common.Utils.idFromHref(probeHref) + "/jobs");
        }

        public getSideBarUpperCardClassForType(elementType: TopologyElementType): string {
            if (elementType === TopologyElementType.NetworkNode) {
                return "md-card-secondary-upper-node";
            } else if (elementType === TopologyElementType.Network) {
                return "md-card-secondary-upper-network";
            } else if (elementType === TopologyElementType.Gateway) {
                return "md-card-secondary-upper-gateway";
            } else if (elementType === TopologyElementType.Link) {
                return "md-card-secondary-upper-link";
            } else if (elementType === TopologyElementType.Probe) {
                return "md-card-secondary-upper-probe";
            } else if (elementType === TopologyElementType.Hotspot) {
                return "md-card-secondary-upper-hotspot";
            } else if (elementType === TopologyElementType.Switch) {
                return "md-card-secondary-upper-son-node";
            } else {
                return "md-card-secondary-upper-default";
            }
        }

        public getSideBarLowerCardClassForType(elementType: TopologyElementType): string {
            if (elementType === TopologyElementType.NetworkNode) {
                return "md-card-secondary-lower-node";
            } else if (elementType === TopologyElementType.Gateway) {
                return "md-card-secondary-lower-gateway";
            } else if (elementType === TopologyElementType.Probe) {
                return "md-card-secondary-lower-probe";
            } else if (elementType === TopologyElementType.Hotspot) {
                return "md-card-secondary-lower-hotspot";
            } else if (elementType === TopologyElementType.Switch) {
                return "md-card-secondary-lower-son-node";
            } else {
                return "";
            }
        }

        public searchByText(text: string): void {
            this.topologyElementService.searchByText(text).then((searchResults: Models.ITopologySearchResult[]) => {
                searchResults = searchResults.map((searchResult: Models.ITopologySearchResult) => {
                    let visObject: {image: string} = this.searchInVis("/" + searchResult.simplifiedHref);
                    if (visObject) {
                        searchResult.icon = visObject.image;
                        return searchResult;
                    } else {
                        return undefined;
                    }
                }).filter((searchResult: Models.ITopologySearchResult) => {
                   return searchResult;
                });
                this.searchResults = searchResults;
            });
        }

        public searchSelected(obj: Models.ITopologySearchResult): void {
            this.zoomToId(obj.simplifiedHref);
        }
        
        public goToElement(searchResult: Models.ITopologySearchResult): void {
            let href: string = searchResult.simplifiedHref;
            this.zoomToId(href);
            this.searchResults = [];
            this.searchText = undefined; 
        }

        public edgeMode(type?: 'none' | 'link' | 'multiblock'): void {
            if (type === 'link') {
                if (this.visNetwork)
                    this.visNetwork.addEdgeMode();
                this.visEdgeMode = true;
                this.visEdgeMultiblockMode = false;
            } else if (type === 'multiblock') {
                if (this.visNetwork)
                    this.visNetwork.addEdgeMode();
                this.visEdgeMode = false;
                this.visEdgeMultiblockMode = true;
            } else {
                if (this.visNetwork)
                    this.visNetwork.enableEditMode();
                this.visEdgeMode = false;
                this.visEdgeMultiblockMode = false;
            }
        }

        public toggleSonIsolate(): void {
            this.sonIsolated = !this.sonIsolated;
            if (this.sonIsolated) {
                this.expandSonNetwork(false);
                this.$cookies.put(NetworkMapController.SON_ISOLATED_COOKIE, "1");
                (this.visData.nodes as vis.DataSet).clear();
            } else {
                this.collapseSonNetwork();
                this.$cookies.remove(NetworkMapController.SON_ISOLATED_COOKIE);
            }
            this.setVisNodes();
            this.visNetwork.fit();
        }

        public humanReadableBits(bits: number): string {
            return Common.Utils.kibiHumanReadableBits(bits, 2);
        }

        public canAddExistingNetworkNodes(href?: string): boolean {
            if (this.nodesNoPos === undefined || this.nodesNoPos.length === 0)
                return false;

            if (!!href) { // can add (write) an specific network node
                for (let n of this.nodesNoPos) {
                    if (n.href === href) {
                        return (n as Models.NetworkNode).canWrite;
                    }
                }
            } else { // can add (write) any network node
                for (let n of this.nodesNoPos) {
                    if ((n as Models.NetworkNode).canWrite) {
                        return true;
                    }
                }
                return false;
            }
        }

        public canAddExistingProbes(href?: string): boolean {
            if (!this.probesNoPos)
                return false;

            if (!!href) { // can add (write) an specific probe
                for (let p of this.probesNoPos) {
                    if (p.href === href) {
                        if ((p as Models.Probe).canWrite) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                }
            } else { // can add (write) any probe
                for (let p of this.probesNoPos) {
                    if ((p as Models.Probe).canWrite) {
                        return true;
                    }
                }
                return false;
            }
        }

        public doSnapToGrid(): void {
            this.snapToGrid();
        }

        private checkPermissionToLink(fromHref: string, toHref: string): boolean {
            let topologyElement: Models.ITopologyElement;
            if (fromHref.indexOf('networks/') > -1) {
                topologyElement = Models.TopologyElement.findElementInAll(this.allTopologyElements, toHref);
            } else if (toHref.indexOf('networks/') > -1) {
                topologyElement = Models.TopologyElement.findElementInAll(this.allTopologyElements, fromHref);
            }

            if (topologyElement && topologyElement.canWrite) {
                return true;
            }

            return false;
        }

        private initVis(): void {
            this.deleteLinkMode = false;
            this.visNetwork = undefined;
            this.visData = {
                nodes: new vis.DataSet({}),
                edges: new vis.DataSet({}),
            };
            this.edgeMode('none');
            this.oneClickDone = false;

            this.visOptions = {
                autoResize: true,
                interaction: {
                    multiselect: true,
                    navigationButtons: true,
                    hover: true,
                    hideEdgesOnDrag: false, // set with lot of links ?
                    tooltipDelay: 200,
                    // hideNodesOnDrag: true, // :D
                },
                manipulation: {
                    enabled: false,
                    addEdge: (data: Vis.IEdge, callback: Vis.Callback): void => {
                        if (this.visEdgeMode) {
                            if (Models.TopologyElement.areLinkableElements(data.from, data.to)) {
                                if (this.checkPermissionToLink(data.from, data.to)) {
                                    this.openLinkModal(data.from, data.to);
                                } else {
                                    this.modalService.showModal({
                                        templateUrl: Controllers.InfoModalController.templateURL,
                                        controller: Controllers.InfoModalController.$name,
                                        inputs: {
                                            title: 'Not allowed',
                                            description: 'You are not allowed to create this link.',
                                        },
                                    }).then((modal: ngModal.IModalObject) => {
                                        let modalElem: UIkit.ModalElement = UIkit.modal(Controllers.InfoModalController.ID,
                                            {bgclose: false, modal: false, keyboard: false});
                                        modalElem.show();
                                        modal.close.then((result: Object) => {
                                            modalElem.hide();
                                        });
                                    });
                                }
                            } else {
                                this.modalService.showModal({
                                    templateUrl: Controllers.InfoModalController.templateURL,
                                    controller: Controllers.InfoModalController.$name,
                                    inputs: {
                                        title: 'Incompatible link',
                                        description: 'The elements are not compatible to be linked.',
                                    },
                                }).then((modal: ngModal.IModalObject) => {
                                    let modalElem: UIkit.ModalElement = UIkit.modal(Controllers.InfoModalController.ID,
                                        {bgclose: false, modal: false, keyboard: false});
                                    modalElem.show();
                                    modal.close.then((result: Object) => {
                                        modalElem.hide();
                                    });
                                });
                            }
                        } else if (this.visEdgeMultiblockMode) {
                            if (data && data.from && data.to) {
                                this.$q.all([
                                    this.blockService.blocksInNode(Common.Utils.idFromHref(data.from)),
                                    this.blockService.blocksInNode(Common.Utils.idFromHref(data.to)),
                                ]).then((res: [Models.Block[], Models.Block[]]) => {
                                    if (Models.MultiBlock.areCompatibleBlocks(res[0], res[1])) {
                                        let blocks: Models.Block[] = res[0].concat(res[1]);
                                        this.modalService.showModal({
                                            templateUrl: Controllers.MultiBlockModalController.templateUrl,
                                            controller: Controllers.MultiBlockModalController.$name,
                                            inputs: {
                                                blocks: blocks,
                                            },
                                        }).then((modal: ngModal.IModalObject) => {
                                            let modalElem: UIkit.ModalElement = UIkit.modal(Controllers.MultiBlockModalController.id,
                                                { bgclose: false, modal: false, keyboard: false });
                                            modalElem.show();
                                            modal.close.then((result: {name: string, srcConn: number, dstConn: number}) => {
                                                modalElem.hide();
                                                this.edgeMode('none');
                                                if (result) {
                                                    this.multiBlockService.createMultiBlock({
                                                        "name": result.name,
                                                        "origBlockConnectionId": result.srcConn,
                                                        "destBlockConnectionId": result.dstConn,
                                                    }).then((mb: Models.MultiBlock) => {
                                                        this.backendMultiblocks.push(mb);
                                                        this.setVisEdges();
                                                    });
                                                }
                                            });
                                        });
                                    } else {
                                        Common.Utils.alertOnInfo('Incompatible multiblock');
                                    }
                                });
                            }
                        }
                    },
                },
                nodes: {
                    shape: 'image',
                    shapeProperties: {
                        interpolation: true,
                    },
                    physics: false,
                },
                edges: {
                    smooth: false,
                    physics: false,
                },
                physics: {
                    stabilization: false,
                },
            };

            this.visEvents = {
                click: (data: Vis.IProperties): void => { this.clickEvent(data); },
                oncontext: (data: Vis.IProperties): void => { this.rightClickEvent(data); },
                dragStart: (data: Vis.IProperties): void => {
                    this.edgeMode('none');
                    this.dragStartData = data;
                    // hack to move all the son switches together
                    if (data.nodes.length > 0 && data.nodes[0].indexOf(SonNode.switchesPreHref) > -1) {
                        let selection: string[] = [];
                        this.backendSonElements.switches.map((s: Models.ISonNode) => {
                            selection.push(s.href);
                        });
                        this.visNetwork.selectNodes(selection);
                    }
                    // hack to move all the son switches together
                },
                dragEnd: (data: Vis.IProperties): void => {
                    this.dragEndEvent(data);
                },
                dragging: (): void => { this.edgeMode('none'); },
                selectNode: (data: Vis.IProperties): void => { this.edgeMode('none'); },
                deselectNode: (data: Vis.IProperties): void => { this.edgeMode('none'); },
                release: (): void => { this.edgeMode('none'); },
                hold: (): void => { this.edgeMode('none'); },
                doubleClick: (data: Vis.IProperties): void => {
                    this.doubleClickEvent(data);
                },
            };
        }

        private getCreationPermissions(): void {
            this.$q.all([
                this.aclService.canCreate('networkNodes'),
                this.aclService.canCreate('networks'),
                this.aclService.canCreate('probes'),
                this.aclService.canCreate('gateways'),
                // this.aclService.canCreate('hotspots'), // TODO: the backend always returns false
                // this.aclService.canCreate('multiblocks'), // TODO: the backend always returns false
                this.aclService.canRead('io.epiclabs.flex.api.WebApplication', 19),
            ]).then((res: boolean[]) => {
                this.canCreate = {
                    networkNodes: res[0] ? res[0] : false,
                    networks: res[1] ? res[1] : false,
                    probes: res[2] ? res[2] : false,
                    gateways: res[3] ? res[3] : false,
                    hotspots: res[1] ? res[1] : false,
                    multiblocks: res[4] ? res[4] : false,
                    links: true,
                };
            });
        }

        private loadBlocksForNetworkNodes(): void {
            const promises: ng.IPromise<Models.IBlock[]>[] = this.backendNetworkNodes
                .map((networkNode: Models.INetworkNode) =>
                    this.blockService.blocksInNode(Common.Utils.idFromHref(networkNode.href), false));

            this.$q.all(promises)
                .then((blocks: Models.IBlock[][]) => {
                    for (let i: number = 0; i < this.backendNetworkNodes.length; i++) {
                        this.backendNetworkNodes[i].blocks = blocks[i];
                    }
                    this.loadSonStats().then(() => this.setVisEdges());
                });
        }

        private loadBlocksForNetworkNode(networkNode: Models.INetworkNode): void {
            let index: number = TopologyElement.findIndex(this.backendNetworkNodes as TopologyElement[], networkNode.href);
            this.blockService.blocksInNode(Common.Utils.idFromHref(networkNode.href), false)
                .then((blocks: Models.IBlock[]) => {
                    this.backendNetworkNodes[index].blocks = blocks;
                    this.loadSonStats().then(() => this.setVisEdges());
                });
        }

        private getAndDrawAllTopologyElements(firstLoad?: boolean): ng.IPromise<void> {
            this.selectedElement = undefined;
            return this.topologyElementService
                .getAllTopologyElements()
                .then((allTopologyElements: Models.IAllTopologyElements) => {

                    this.nodesNoPos = [];
                    this.probesNoPos = [];
                    this.allTopologyElements = allTopologyElements;
                    this.backendNetworkNodes = allTopologyElements ? allTopologyElements.networkNodes : this.backendNetworkNodes;

                    this.backendNetworks = allTopologyElements ? allTopologyElements.networks : this.backendNetworks;
                    this.backendGateways = allTopologyElements ? allTopologyElements.gateways : this.backendGateways;
                    this.backendProbes = allTopologyElements ? allTopologyElements.probes : this.backendProbes;
                    this.backendHotspots = allTopologyElements ? allTopologyElements.hotspots : this.backendHotspots;
                    this.backendLinks = allTopologyElements ? allTopologyElements.links : this.backendLinks;
                    this.backendMultiblocks = allTopologyElements ? allTopologyElements.multiblocks : this.backendMultiblocks;
                    this.mags = allTopologyElements.networkNodes.filter((value: Models.NetworkNode) => {
                        return "" + value.type.id === "" + 10;
                    });
                    this.backendSonElements.switches = allTopologyElements ? allTopologyElements.sonNodes : [];
                    this.backendSonElements.links = allTopologyElements ? allTopologyElements.sonLinks : [];
                    this.backendSonElements.showSonCollapsed = true;

                    this.loadPacketMap();
                    this.loadBlocksForNetworkNodes();
                    this.burnishSonInfoForNetworkNodes();

                    if (!firstLoad) {
                        (this.visData.nodes as vis.DataSet).clear();
                        (this.visData.edges as vis.DataSet).clear();
                    }

                    return this.setPermissions().then(() => {
                        this.setVisNodes();
                        this.setVisEdges(firstLoad);
                        if (firstLoad) {
                            this.$timeout(() => {
                                if (this.zoomType) {
                                    this.zoomToId(this.zoomType + "/" + this.zoomId);
                                } else {
                                    if (this.visNetwork !== undefined) this.visNetwork.fit();
                                }
                                if (this.$cookies.get(NetworkMapController.SON_NETWORK_COOKIE)) {
                                    this.expandSonNetwork();
                                }
                                if (this.userIsAdmin && this.$cookies.get(NetworkMapController.SON_ISOLATED_COOKIE)) {
                                    this.toggleSonIsolate();
                                }

                                this.canAddExisting.networkNodes = this.canAddExistingNetworkNodes();
                                this.canAddExisting.probes = this.canAddExistingProbes();
                            });
                        }
                        this.searchByText("");
                        return;
                    });
                })
                .catch((reason: ngCustom.IReason) => {
                    this.messageTranslationsService.showPromiseError(reason);
                });
        }

        private setPermissions(): ng.IPromise<void> {
            this.backendHotspots.map((h: Models.ITopologyElement) => h.canWrite = true);
            return this.$q.all([
                this.setPermissionsHelper(this.backendNetworkNodes, 'networkNodes',
                    this.backendNetworkNodes.map((n: Models.ITopologyElement) => {
                        return Common.Utils.idFromHref(n.href);
                    })
                ),
                this.setPermissionsHelper(this.backendNetworks, 'networks',
                    this.backendNetworks.map((n: Models.ITopologyElement) => {
                        return Common.Utils.idFromHref(n.href);
                    })
                ),
                this.setPermissionsHelper(this.backendGateways, 'gateways',
                    this.backendGateways.map((n: Models.ITopologyElement) => {
                        return Common.Utils.idFromHref(n.href);
                    })
                ),
                this.setPermissionsHelper(this.backendProbes, 'probes',
                    this.backendProbes.map((n: Models.ITopologyElement) => {
                        return Common.Utils.idFromHref(n.href);
                    })
                ),
                this.setPermissionsHelper(this.backendHotspots, 'hotspots',
                    this.backendHotspots.map((n: Models.ITopologyElement) => {
                        return Common.Utils.idFromHref(n.href);
                    })
                ),
                this.setPermissionsHelper(this.backendMultiblocks, 'multiblocks',
                    this.backendMultiblocks.map((n: Models.ITopologyElement) => {
                        return Common.Utils.idFromHref(n.href);
                    })
                ),
            ]).then(() => {
                for (let link of this.backendLinks) {
                    this.setPermissionsForLink(link);
                }
                return;
            });
        }

        private setPermissionsForLink(link: Models.ILink): void {
            const nodeHref: string = link.from.href.indexOf('networks/') > -1 ? link.to.href : link.from.href;
            const n: Models.ITopologyElement =
                Models.TopologyElement.findElementInAll(this.allTopologyElements, nodeHref);
            link.canWrite = n ? n.canWrite : false;
        }

        private setPermissionsHelper(data: Models.ITopologyElement[], type: string, ids: number[]): ng.IPromise<void> {
            if (!data || data.length === 0)
                return;

            return this.aclService.canWriteList(type, ids).then((can: boolean[]) => {
                if (!can || can.length !== data.length) {
                    for (let i: number = 0; i < data.length; i++) {
                        data[i].canWrite = false;
                    }
                } else {
                    for (let i: number = 0; i < data.length; i++) {
                        data[i].canWrite = can[i];
                    }
                }
                return;
            }).catch(() => {
                for (let i: number = 0; i < data.length; i++) {
                    data[i].canWrite = false;
                }
                return;
            });
        }

        private burnishSonInfoForNetworkNodes(): void {
            for (let n of this.backendNetworkNodes) {
                n.isSonRelated = this.isSonRelatedElement(n, Models.TopologyElementType.NetworkNode);
            }
        }

        private isSonRelatedElement(el: ITopologyElement, tp: TopologyElementType): boolean {
            const sonNetwork: Models.INetwork = this.getSonNetwork();
            if (sonNetwork && tp === TopologyElementType.NetworkNode) {
                let linksWithSon: Models.ILink[] = this.backendLinks.filter((l: Models.ILink) => {
                    const from: string = l.from.href;
                    const to: string = l.to.href;
                    return (from === sonNetwork.href && to === el.href) || (from === el.href && to === sonNetwork.href);
                });
                return linksWithSon.length > 0;
            }
            return false;
        }

        private loadPacketMap(): ng.IPromise<ISonPacketmap> {
            return this.sonAdapterService.getSonPacketmap().then((packetMap: ISonPacketmap) => {
                this.packetMap = packetMap;
                if (packetMap.switches) {
                    this.backendSonElements.switches = packetMap.switches;
                    for (let switchNode of packetMap.switches) {
                        this.connectedSourcesPerSwitch[switchNode.id] = [];
                        this.connectedDestinationsPerSwitch[switchNode.id] = [];
                        for (let link of packetMap.links) {
                            if (link.source.id === switchNode.id) {
                                this.connectedDestinationsPerSwitch[switchNode.id].push(link.target.name);
                            } else if (link.target.id === switchNode.id) {
                                this.connectedSourcesPerSwitch[switchNode.id].push(link.source.name);
                            }
                        }
                    }
                }
                if (packetMap.links) {
                    this.backendSonElements.links = packetMap.links;
                }
                return this.packetMap;
            });
        }

        private async loadSonStats(): Promise<void> {
            const packetMap: ISonPacketmap = await this.sonAdapterService.getSonPacketmap();
            if (this.backendSonElements) {
                if (this.backendSonElements.links === undefined)
                    this.backendSonElements.links = [];
                this.backendSonElements.links.forEach((link: ISonLink) => link.visited = false);
                if (packetMap) {
                    packetMap.links.forEach((link: ISonLink, i: number) => {
                        let [updatedLink]: ISonLink[] = this.backendSonElements.links.filter((sonLink: ISonLink) => {
                            return sonLink.id === link.id;
                        });
                        if (updatedLink) { // Existing link
                            updatedLink.stats.load = link.stats.load;
                            updatedLink.stats.bitrate = link.stats.bitrate;
                            this.setVisSonLink(updatedLink, undefined, this.visData.edges as vis.DataSet, false);
                            this.storeSonLinkStatsToPlot(i, updatedLink.statsToPlot);
                            updatedLink.visited = true;
                        } else { // new link
                            this.backendSonElements.links.push(link);
                            this.setVisSonLink(link, undefined, this.visData.edges as vis.DataSet, false);
                            this.storeSonLinkStatsToPlot(i, link.statsToPlot);
                            link.visited = true;
                        }
                    });
                    this.backendSonElements.links.filter(link => !link.visited).forEach((link: ISonLink) => {
                        (this.visData.edges as vis.DataSet).remove(link.fromTo);
                    });
                    this.backendSonElements.links = this.backendSonElements.links.filter((link: ISonLink) => link.visited);
                }
            }
        }

        private saveSelectedElementToDB(element?: Models.ITopologyElement): void {
            if (element) this.selectedElement = element;
            this.edgeMode('none');
            if (this.selectedElement) {
                this.topologyElementService.saveTopologyElement((this.selectedElement as Models.ITopologyElement))
                    .then((result: Models.ITopologyElement) => {
                        result.health = this.healthService.getNodeHealth(result.href);
                        this.updateTopologyElement(result as Models.ITopologyElement);
                    }).catch((reason: ngCustom.IReason) => {
                        this.messageTranslationsService.showPromiseError(reason);
                        this.getAndDrawAllTopologyElements(); // if anything was wrong, better refresh all elements from backend
                    });
            }
        }

        private deleteTopologyElementFromDB(): void {
            this.edgeMode('none');
            if (this.selectedElement) {
                let typeToDelete: Models.TopologyElementType;
                let hrefToDelete: string;
                if ((this.selectedElement as Models.Link[]).length > 0) {
                    typeToDelete = Models.TopologyElementType.Link;
                } else {
                    typeToDelete = (this.selectedElement as Models.ITopologyElement).class();
                    hrefToDelete = (this.selectedElement as Models.ITopologyElement).href;
                }
                if (typeToDelete !== Models.TopologyElementType.Link) {
                    this.topologyElementService
                        .deleteTopologyElement((this.selectedElement as Models.ITopologyElement))
                        .then((result: ITopologyElement | boolean) => {
                            // updating backendNetworkNodes
                            if (typeToDelete === Models.TopologyElementType.NetworkNode) {
                                // if (this.selectedElement.net)
                                let i: number = TopologyElement.findIndex(this.backendNetworkNodes as TopologyElement[], hrefToDelete);
                                let canWrite: boolean = this.backendNetworkNodes[i].canWrite;
                                this.backendNetworkNodes[i] = result as Models.INetworkNode;
                                this.backendNetworkNodes[i].canWrite = canWrite;
                                (this.visData.nodes as vis.DataSet).remove(hrefToDelete);
                                this.nodesNoPos.push(this.selectedElement as Models.INetworkNode);
                            // updating backendNetworks
                            } else if (typeToDelete === Models.TopologyElementType.Network) {
                                let i: number = TopologyElement.findIndex(this.backendNetworks as TopologyElement[], hrefToDelete);
                                if (i !== undefined) this.backendNetworks.splice(i, 1);
                                (this.visData.nodes as vis.DataSet).remove(hrefToDelete);
                            // updating backendGateways
                            } else if (typeToDelete === Models.TopologyElementType.Gateway) {
                                let i: number = TopologyElement.findIndex(this.backendGateways as TopologyElement[], hrefToDelete);
                                if (i !== undefined) this.backendGateways.splice(i, 1);
                                (this.visData.nodes as vis.DataSet).remove(hrefToDelete);
                            // updating backendProbes
                            } else if (typeToDelete === Models.TopologyElementType.Probe) {
                                let i: number = TopologyElement.findIndex(this.backendProbes as TopologyElement[], hrefToDelete);
                                this.backendProbes[i] = result as Models.IProbe;
                                (this.visData.nodes as vis.DataSet).remove(hrefToDelete);
                                this.probesNoPos.push(this.selectedElement as Models.IProbe);
                            // updating backendHotspots
                            } else if (typeToDelete === Models.TopologyElementType.Hotspot) {
                                let i: number = TopologyElement.findIndex(this.backendHotspots as TopologyElement[], hrefToDelete);
                                if (i !== undefined) this.backendHotspots.splice(i, 1);
                                (this.visData.nodes as vis.DataSet).remove(hrefToDelete);
                            }
                            // redraw the edges
                            this.setVisEdges();
                            this.keepSidebar = true;
                            this.selectedElement = undefined;
                        })
                        .catch((reason: ngCustom.IReason) => {
                            this.messageTranslationsService.showPromiseError(reason);
                            this.getAndDrawAllTopologyElements(); // if anything was wrong, better refresh all elements from backend
                        });
                } else {
                    (this.selectedElement as Models.ILink[]).forEach((link: Models.Link) => {
                        this.topologyElementService
                            .deleteTopologyElement(link)
                            .then((result: Models.ITopologyElement | boolean) => {
                                // updating backendLinks
                                let i: number = TopologyElement.findIndex(this.backendLinks as TopologyElement[], link.href);
                                if (i !== undefined) this.backendLinks.splice(i, 1);
                                // updating the vis model
                                let fromTo: string = Common.Utils.idFromHref(link.from.href) + '-' + Common.Utils.idFromHref(link.to.href);
                                (this.visData.edges as vis.DataSet).remove(fromTo);
                                // updating the device that was linked to the network
                                let device: TopologyElement = new TopologyElement;
                                if ((link as Models.ILink).from.href.indexOf('networks/') === -1) {
                                    device.href = link.from.href;
                                } else {
                                    device.href = link.to.href;
                                }
                                this.topologyElementService.getTopologyElement(device).then((r: Models.ITopologyElement) => {
                                    if (r.class() === Models.TopologyElementType.NetworkNode) {
                                        let i: number = TopologyElement.findIndex(this.backendNetworkNodes as TopologyElement[], r.href);
                                        r.canWrite = this.backendNetworkNodes[i].canWrite;
                                        this.backendNetworkNodes[i] = r as Models.NetworkNode;
                                    } else if (r.class() === Models.TopologyElementType.Gateway) {
                                        let i: number = TopologyElement.findIndex(this.backendGateways as TopologyElement[], r.href);
                                        r.canWrite = this.backendGateways[i].canWrite;
                                        this.backendGateways[i] = r as Models.Gateway;
                                    } else if (r.class() === Models.TopologyElementType.Hotspot) {
                                        let i: number = TopologyElement.findIndex(this.backendHotspots as TopologyElement[], r.href);
                                        r.canWrite = this.backendHotspots[i].canWrite;
                                        this.backendHotspots[i] = r as Models.Hotspot;
                                    } else if (r.class() === Models.TopologyElementType.Probe) {
                                        let i: number = TopologyElement.findIndex(this.backendProbes as TopologyElement[], r.href);
                                        r.canWrite = this.backendProbes[i].canWrite;
                                        this.backendProbes[i] = r as Models.Probe;
                                    }
                                    this.keepSidebar = true;
                                    this.selectedElement = undefined;
                                });
                            })
                            .catch((reason: ngCustom.IReason) => {
                                this.messageTranslationsService.showPromiseError(reason);
                                this.getAndDrawAllTopologyElements(); // if anything was wrong, better refresh all elements from backend
                            });
                    });
                }
            }
        }

        private createTopologyElement(el: ITopologyElement): void {
            if (el === undefined || el.href === undefined || el.href === '')
                return;
            let tp: TopologyElementType = TopologyElement.getElementTypeByHref(el.href);
            if (tp === TopologyElementType.NetworkNode) {
                let nn: Models.NetworkNode = el as Models.NetworkNode;
                this.setPermissionsHelper([nn], 'networkNodes', [Common.Utils.idFromHref(nn.href)]).then(() => {
                    this.backendNetworkNodes.push(nn);
                    this.nodesNoPos.push(nn);
                    this.loadBlocksForNetworkNode(nn);
                    if (this.topologyElementService.isNodeCoordinateDefined(nn)) {
                        this.updateTopologyElement(nn);
                    }
                });
            } else if (tp === TopologyElementType.Network) {
                this.updateTopologyElement(el);
            } else if (tp === TopologyElementType.Gateway) {
                this.updateTopologyElement(el);
            } else if (tp === TopologyElementType.Hotspot) {
                this.updateTopologyElement(el);
            } else if (tp === TopologyElementType.Probe) {
                let p: Models.Probe = el as Models.Probe;
                this.setPermissionsHelper([p], 'probes', [Common.Utils.idFromHref(p.href)]).then(() => {
                    this.backendProbes.push(p);
                    this.probesNoPos.push(p);
                    if (this.topologyElementService.isNodeCoordinateDefined(p)) this.updateTopologyElement(p);
                });
            } else if (tp === TopologyElementType.Link) {
                let l: Models.Link = el as Models.Link;
                this.backendLinks.push(l);
                this.burnishSonInfoForNetworkNodes();
            }
            this.setVisEdges();
        }

        private getSonNetwork(): Models.INetwork {
            for (let n of this.backendNetworks) {
                if (n.type === Models.NetworkType.SON) {
                    return n;
                }
            }
            return undefined;
        }

        private updateBackendNetworkNode(nn: Models.NetworkNode): void {
            let i: number = TopologyElement.findIndex(this.backendNetworkNodes as TopologyElement[], nn.href);
            let canWrite: boolean = this.backendNetworkNodes[i].canWrite;
            this.backendNetworkNodes[i] = nn;
            this.backendNetworkNodes[i].canWrite = canWrite;
        }

        private updateTopologyElement(el: ITopologyElement, updateEdges?: boolean): void {
            if (el === undefined || el.href === undefined || el.href === '')
                return;
            const tp: TopologyElementType = TopologyElement.getElementTypeByHref(el.href);
            if (this.sonIsolated && (el as Models.INetwork).type !== Models.NetworkType.SON && !(el as Models.INetworkNode).isSonRelated) {
                if (tp === TopologyElementType.NetworkNode) {
                    this.updateBackendNetworkNode(el as Models.NetworkNode);
                    // Remove it from the SON isolated view!
                    (this.visData.nodes as vis.DataSet).remove(el.href);
                }
                return;
            }
            if (tp === TopologyElementType.NetworkNode) {
                let nn: Models.NetworkNode = el as Models.NetworkNode;
                this.updateBackendNetworkNode(nn);
                // updating vis model and nodesNoPos

                if (this.topologyElementService.isNodeCoordinateDefined(nn)) {
                    (this.visData.nodes as vis.DataSet).update({
                        id: nn.href,
                        label: nn.getDisplayLabel(),
                        x: nn.x,
                        y: nn.y,
                        image: nn.getDisplayImage(),
                        fixed: !nn.canWrite,
                    });
                    let j: number = TopologyElement.findIndex(this.nodesNoPos as TopologyElement[], nn.href);
                    if (j !== undefined) this.nodesNoPos.splice(j, 1);
                    // updating selectedElement
                    if (this.selectedElement !== undefined && (this.selectedElement as Models.NetworkNode).href === nn.href) {
                        this.selectedElement = nn;
                    }
                    // updating links
                    for (let nic of nn.networkInterfaces) {
                        for (let bLink of this.backendLinks) {
                            if (bLink.networkInterface.id === nic.id) {
                                bLink.networkInterface = nic;
                            }
                        }
                    }
                } else {
                    (this.visData.nodes as vis.DataSet).remove(nn.href);
                    let j: number = TopologyElement.findIndex(this.nodesNoPos as TopologyElement[], nn.href);
                    if (j !== undefined) {
                        this.nodesNoPos[j] = nn;
                    } else {
                        this.nodesNoPos.push(nn);
                    }
                    // removing selectedElement
                    if (this.selectedElement !== undefined && (this.selectedElement as Models.NetworkNode).href === nn.href) {
                        this.selectedElement = undefined;
                    }
                }
            } else if (tp === TopologyElementType.Network) {
                let n: Models.Network = el as Models.Network;
                this.setPermissionsHelper([n], 'networks', [Common.Utils.idFromHref(n.href)]).then(() => {
                    // updating backendNetworks
                    let i: number = TopologyElement.findIndex(this.backendNetworks as TopologyElement[], n.href);
                    if (n.type === Models.NetworkType.SON && this.backendSonElements.switches !== undefined &&
                        !this.backendSonElements.showSonCollapsed) {
                        this.updateSonNetwork(n);
                        return;
                    }
                    if (i !== undefined) {
                        this.backendNetworks[i] = n;
                    } else {
                        this.backendNetworks.push(n);
                    }
                    // updating vis model
                    (this.visData.nodes as vis.DataSet).update({
                        id: n.href,
                        label: this.showIps ? n.getDisplayLabelWithIpMask() : n.getDisplayLabel(),
                        x: n.x,
                        y: n.y,
                        image: n.getDisplayImage(),
                        fixed: !n.canWrite,
                    });
                    // updating selectedElement
                    if (this.selectedElement !== undefined && (this.selectedElement as Models.Network).href === n.href) {
                        this.selectedElement = n;
                    }
                });
            } else if (tp === TopologyElementType.Gateway) {
                let g: Models.Gateway = el as Models.Gateway;
                this.setPermissionsHelper([g], 'gateways', [Common.Utils.idFromHref(g.href)]).then(() => {
                    // updating backendGateways
                    const i: number = TopologyElement.findIndex(this.backendGateways as TopologyElement[], g.href);
                    if (i !== undefined) {
                        this.backendGateways[i] = g;
                    } else {
                        this.backendGateways.push(g);
                    }
                    // updating vis model
                    (this.visData.nodes as vis.DataSet).update({
                        id: g.href,
                        label: g.getDisplayLabel(),
                        x: g.x,
                        y: g.y,
                        image: g.getDisplayImage(),
                        fixed: !g.canWrite,
                    });
                    // updating links
                    for (let nic of g.networkInterfaces) {
                        for (let bLink of this.backendLinks) {
                            if (bLink.networkInterface.id === nic.id) {
                                bLink.networkInterface = nic;
                            }
                        }
                    }
                    // updating selectedElement
                    if (this.selectedElement !== undefined && (this.selectedElement as Models.Gateway).href === g.href) {
                        this.selectedElement = g;
                    }
                });
            } else if (tp === TopologyElementType.Hotspot) {
                let h: Models.Hotspot = el as Models.Hotspot;
                h.canWrite = true; // god mode for hotspots
                // updating backendHotspots
                let i: number = TopologyElement.findIndex(this.backendHotspots as TopologyElement[], h.href);
                if (i !== undefined) {
                    this.backendHotspots[i] = h;
                } else {
                    this.backendHotspots.push(h);
                }
                // updating vis model
                (this.visData.nodes as vis.DataSet).update({
                    id: h.href,
                    label: h.getDisplayLabel(),
                    x: h.x,
                    y: h.y,
                    image: h.getDisplayImage(),
                    fixed: !h.canWrite,
                });
                // updating links
                for (let nic of h.networkInterfaces) {
                    for (let bLink of this.backendLinks) {
                        if (bLink.networkInterface.id === nic.id) {
                            bLink.networkInterface = nic;
                        }
                    }
                }
                // updating selectedElement
                if (this.selectedElement !== undefined && (this.selectedElement as Models.Gateway).href === h.href) {
                    this.selectedElement = h;
                }
            } else if (tp === TopologyElementType.Probe) {
                let p: Models.Probe = el as Models.Probe;
                this.setPermissionsHelper([p], 'probes', [Common.Utils.idFromHref(p.href)]).then(() => {
                    // updating backendNetworkNodes
                    let i: number = TopologyElement.findIndex(this.backendProbes as TopologyElement[], p.href);
                    this.backendProbes[i] = p;
                    // updating vis model and probesNoPos
                    if (this.topologyElementService.isNodeCoordinateDefined(p)) {
                        (this.visData.nodes as vis.DataSet).update({
                            id: p.href,
                            label: p.getDisplayLabel(),
                            x: p.x,
                            y: p.y,
                            image: p.getDisplayImage(),
                            fixed: !p.canWrite,
                        });
                        let j: number = TopologyElement.findIndex(this.probesNoPos as TopologyElement[], p.href);
                        if (j !== undefined) this.probesNoPos.splice(j, 1);
                        // updating selectedElement
                        if (this.selectedElement !== undefined && (this.selectedElement as Models.NetworkNode).href === p.href) {
                            this.selectedElement = p;
                        }
                        // updating links
                        for (let nic of p.networkInterfaces) {
                            for (let bLink of this.backendLinks) {
                                if (bLink.networkInterface.id === nic.id) {
                                    bLink.networkInterface = nic;
                                }
                            }
                        }
                    } else {
                        (this.visData.nodes as vis.DataSet).remove(p.href);
                        let j: number = TopologyElement.findIndex(this.probesNoPos as TopologyElement[], p.href);
                        if (j !== undefined) {
                            this.probesNoPos[j] = p;
                        } else {
                            this.probesNoPos.push(p);
                        }
                        // removing selectedElement
                        if (this.selectedElement !== undefined && (this.selectedElement as Models.NetworkNode).href === p.href) {
                            this.selectedElement = undefined;
                        }
                    }
                });
            } else if (tp === TopologyElementType.Link) {
                // this operation doesn't exist
            }
            if (updateEdges !== false) {
                this.setVisEdges();
            }
        }

        private updateSonNetwork(n: Application.Models.Network): void {
            this.backendSonElements.center = {
                x: n.x,
                y: n.y,
            };
            this.backendSonElements.sonNetwork = n;
            this.backendSonElements.switches.filter(
                (node: Models.ISonNode) => { return node.group !== 'vport'; })
                .map((e: Models.ISonNode, i: number) => {
                e.index = i;
                this.updateTopologySonElement(e, false);
            });
            // this.setVisEdges();
        }

        private updateTopologyElementPosition(el: TopologyElement, x: number, y: number): void {
            // here, "el" is not a complete element (but it has href)! we are going to use each backendList instead
            if (el === undefined || el.href === undefined || el.href === '')
                return;
            let tp: TopologyElementType = TopologyElement.getElementTypeByHref(el.href);
            if (tp === TopologyElementType.NetworkNode) {
                let nn: Models.NetworkNode = el as Models.NetworkNode;
                let i: number = TopologyElement.findIndex(this.backendNetworkNodes as TopologyElement[], nn.href);
                if (i !== undefined) {
                    [this.backendNetworkNodes[i].x, this.backendNetworkNodes[i].y] = [x, y];
                    this.updateTopologyElement(this.backendNetworkNodes[i], false);
                }
            } else if (tp === TopologyElementType.Network) {
                let n: Models.Network = el as Models.Network;
                let i: number = TopologyElement.findIndex(this.backendNetworks as TopologyElement[], n.href);
                if (i !== undefined) {
                    [this.backendNetworks[i].x, this.backendNetworks[i].y] = [x, y];
                    this.updateTopologyElement(this.backendNetworks[i], false);
                }
            } else if (tp === TopologyElementType.Gateway) {
                let g: Models.Gateway = el as Models.Gateway;
                let i: number = TopologyElement.findIndex(this.backendGateways as TopologyElement[], g.href);
                if (i !== undefined) {
                    [this.backendGateways[i].x, this.backendGateways[i].y] = [x, y];
                    this.updateTopologyElement(this.backendGateways[i], false);
                }
            } else if (tp === TopologyElementType.Hotspot) {
                let h: Models.IHotspot = el as Models.IHotspot;
                let i: number = TopologyElement.findIndex(this.backendHotspots as TopologyElement[], h.href);
                if (i !== undefined) {
                    [this.backendHotspots[i].x, this.backendHotspots[i].y] = [x, y];
                    this.updateTopologyElement(this.backendHotspots[i], false);
                }
            } else if (tp === TopologyElementType.Probe) {
                let p: Models.IProbe = el as Models.IProbe;
                let i: number = TopologyElement.findIndex(this.backendProbes as TopologyElement[], p.href);
                if (i !== undefined) {
                    [this.backendProbes[i].x, this.backendProbes[i].y] = [x, y];
                    this.updateTopologyElement(this.backendProbes[i], false);
                }
            }
        }

        private updateTopologySonElement(el: Models.ISonNode, updateEdges?: boolean): void {
            if (el === undefined || el.href === undefined || el.href === '')
                return;
            const radius: number = 150;
            if (TopologyElement.getElementTypeByHref(el.href) === TopologyElementType.Switch) {
                let n: Models.SonNode = el as Models.SonNode;

                // calculating the coordinates to be placed around the son network, ignoring virtual ports
                let alpha: number = el.index * 2 * Math.PI / this.backendSonElements.switches.filter(
                        (node: Models.ISonNode) => { return node.group !== 'vport'; }).length;

                el.x = this.backendSonElements.center.x + radius * Math.sin(alpha);
                el.y = this.backendSonElements.center.y + radius * Math.cos(alpha);


                // updating backendSonElements.switches
                let i: number = TopologyElement.findIndex(this.backendSonElements.switches as TopologyElement[], n.href);
                this.backendSonElements.switches[i] = n;
                // updating the vis model
                (this.visData.nodes as vis.DataSet).update({
                    id: n.href,
                    label: n.getDisplayLabel(),
                    x: el.x,
                    y: el.y,
                    image: n.getDisplayImage(),
                    physics: false,
                });

                // now paint the ports for this switch
                // TODO: This will only paint the first port, make sure we paint all of them
                // const nodePortCount: number = this.backendSonElements.getPortsConnectedToNode( n ).length;
                const portX: number = (el.x - this.backendSonElements.center.x) / 1.25 + el.x;
                const portY: number = (el.y - this.backendSonElements.center.y) / 1.25 + el.y;

                this.backendSonElements.getPortsConnectedToNode( n ).forEach( ( port: Models.SonNode, index: number ) => {
                    port.x = portX;
                    port.y = portY;

                    (this.visData.nodes as vis.DataSet).update({
                        id: port.href,
                        label: port.getDisplayLabel(),
                        x: port.x,
                        y: port.y,
                        image: port.getDisplayImage(),
                        physics: false,
                    });
                });

            }
            if (updateEdges !== false) {
                this.setVisEdges();
            }
        }

        private deleteTopologyElement(id: number, tp: TopologyElementType): void {
            if (tp === TopologyElementType.NetworkNode) {
                // updating backendNetworkNodes
                let i: number = TopologyElement.findIndexById(this.backendNetworkNodes as TopologyElement[], id);
                if (i !== undefined) this.backendNetworkNodes.splice(i, 1);
                // updating nodesNoPos XOR vis model
                let j: number = TopologyElement.findIndexById(this.nodesNoPos as TopologyElement[], id);
                if (j !== undefined) {
                    this.nodesNoPos.splice(j, 1);
                } else {
                    let href: string;
                    (this.visData.nodes as vis.DataSet).forEach((n: {id: string}) => {
                        if (Common.Utils.idFromHref(n.id) === id) {
                            href = n.id;
                        }
                    });
                    (this.visData.nodes as vis.DataSet).remove(href);
                    // updating selectedElement
                    if (this.selectedElement !== undefined && (this.selectedElement as Models.NetworkNode).href === href) {
                        this.selectedElement = undefined;
                    }
                }
            } else if (tp === TopologyElementType.Network) {
                // updating backendNetworks
                let i: number = TopologyElement.findIndexById(this.backendNetworks as TopologyElement[], id);
                if (i !== undefined) this.backendNetworks.splice(i, 1);
                // updating vis model
                let j: string;
                (this.visData.nodes as vis.DataSet).forEach((n: {id: string}) => {
                    if (Common.Utils.idFromHref(n.id) === id) {
                        j = n.id;
                    }
                });
                (this.visData.nodes as vis.DataSet).remove(j);
                // updating selectedElement
                if (this.selectedElement !== undefined && (this.selectedElement as Models.Network).href === j) {
                    this.selectedElement = undefined;
                }
            } else if (tp === TopologyElementType.Gateway) {
                // updating backendGateways
                let i: number = TopologyElement.findIndexById(this.backendGateways as TopologyElement[], id);
                if (i !== undefined) this.backendGateways.splice(i, 1);
                // updating vis model
                let j: string;
                (this.visData.nodes as vis.DataSet).forEach((n: {id: string}) => {
                    if (Common.Utils.idFromHref(n.id) === id) {
                        j = n.id;
                    }
                });
                (this.visData.nodes as vis.DataSet).remove(j);
                // updating selectedElement
                if (this.selectedElement !== undefined && (this.selectedElement as Models.Gateway).href === j) {
                    this.selectedElement = undefined;
                }
            } else if (tp === TopologyElementType.Hotspot) {
                // updating backendHotspots
                let i: number = TopologyElement.findIndexById(this.backendHotspots as TopologyElement[], id);
                if (i !== undefined) this.backendHotspots.splice(i, 1);
                // updating vis model
                let j: string;
                (this.visData.nodes as vis.DataSet).forEach((n: {id: string}) => {
                    if (Common.Utils.idFromHref(n.id) === id) {
                        j = n.id;
                    }
                });
                (this.visData.nodes as vis.DataSet).remove(j);
                // updating selectedElement
                if (this.selectedElement !== undefined && (this.selectedElement as Models.Gateway).href === j) {
                    this.selectedElement = undefined;
                }
            } else if (tp === TopologyElementType.Probe) {
                // updating backendProbes
                let i: number = TopologyElement.findIndexById(this.backendProbes as TopologyElement[], id);
                if (i !== undefined) this.backendProbes.splice(i, 1);
                // updating probesNoPos XOR vis model
                let j: number = TopologyElement.findIndexById(this.probesNoPos as TopologyElement[], id);
                if (j !== undefined) {
                    this.probesNoPos.splice(j, 1);
                } else {
                    let href: string;
                    (this.visData.nodes as vis.DataSet).forEach((p: {id: string}) => {
                        if (Common.Utils.idFromHref(p.id) === id) {
                            href = p.id;
                        }
                    });
                    (this.visData.nodes as vis.DataSet).remove(href);
                    // updating selectedElement
                    if (this.selectedElement !== undefined && (this.selectedElement as Models.Probe).href === href) {
                        this.selectedElement = undefined;
                    }
                }
            } else if (tp === TopologyElementType.Link) {
                let i: number = TopologyElement.findIndexById(this.backendLinks as TopologyElement[], id);
                if (i !== undefined) {
                    // updating backendLinks
                    let href: string = this.backendLinks[i].href;
                    this.backendLinks.splice(i, 1);
                    this.burnishSonInfoForNetworkNodes();
                    // updating vis model
                    (this.visData.edges as vis.DataSet).remove(href);
                    // updating selectedElement
                    if (this.selectedElement !== undefined && (this.selectedElement as Models.Link).href === href) {
                        this.selectedElement = undefined;
                    }
                }
            }
            this.setVisEdges();
        }

        private setVisNodes(): void {
            (this.backendNetworkNodes as TopologyElement[]).concat(
             this.backendNetworks as TopologyElement[],
             this.backendGateways as TopologyElement[],
             this.backendHotspots as TopologyElement[],
             this.backendProbes as TopologyElement[]).map((element: Models.TopologyElement) => {
                this.updateTopologyElement(element, false);
            });
        }

        /*
        * Returns the href of a node only if it is drawn in the map.
        */
        private findNodeHrefInMap(id: number): string {
            for (let n of this.backendNetworkNodes) {
                if (Common.Utils.idFromHref(n.href) === id) {
                    return n.href;
                }
            }
            return undefined;
        }

        private setVisEdges(firstLoad?: boolean): void {
            let visEdges: vis.DataSet = this.visData.edges as vis.DataSet;
            visEdges.clear();
            let arrow: string = '<i class="material-icons">arrow_forward</i>';
            this.backendMultiblocks.map((mb: Models.IMultiBlock) => {
                let edgeId: string = `${mb.leftBlock.networkNodeHref}-MULTIBLOCK-${mb.rightBlock.networkNodeHref}`;
                let edge: Vis.IEdge = visEdges.get(edgeId);
                let title: string = `<div class='uk-clearfix' style='display: block;'>
                                         <span style='font-weight: bold; float: left;'>${mb.name}:&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                         <span style='float: right;'>
                                            ${mb.origBlockConnection.blockName} ${arrow}
                                            <span class='uk-badge'>${mb.origBlockConnection.connectionTypeName}</span> ${arrow}
                                            ${mb.destBlockConnection.blockName}
                                         </span>
                                     </div>`;
                if (edge) {
                    edge.width = 3;
                    edge.label += this.showIps ? `/${mb.origBlockConnection.connectionTypeName}` : '';
                    edge.title += `${title}`;
                    visEdges.update(edge);
                } else {
                    let from: string = this.findNodeHrefInMap(parseInt(mb.leftBlock.networkNodeHref, 10));
                    let to: string = this.findNodeHrefInMap(parseInt(mb.rightBlock.networkNodeHref, 10));
                    if (from && to) {
                        edge = {
                            label: this.showIps ? mb.origBlockConnection.connectionTypeName : '',
                            title: `<p style='margin: 0 0 10px 0;'>Multi Block Connection(s):</p>${title}`,
                            from: from,
                            to: to,
                            id: edgeId,
                            width: 1,
                            color: 'darkseagreen',
                            font: { align: 'middle' },
                            arrows: { to: { enabled: true } },
                        };
                        visEdges.update(edge);
                    }
                }
            });
            this.backendLinks.map((link: Models.ILink) => {
                let edgeId: string = Common.Utils.idFromHref(link.from.href) + '-' + Common.Utils.idFromHref(link.to.href);
                link.fromTo = edgeId;
                let edge: Vis.IEdge = visEdges.get(edgeId);
                if (edge) {
                    // there is already an edge between the two elements
                    edge.width = 3;
                } else {
                    // there is not any edge between the two elements
                    edge = {
                        label: '',
                        title: '',
                        from: link.from.href,
                        to: link.to.href,
                        id: edgeId,
                        width: 1,
                        font: {
                            align: 'middle',
                        },
                        physics: false,
                        smooth: false,
                    };
                }
                let actualLinks: Models.ILink[] = this.backendLinks
                    .filter((l: Models.ILink) => { return l.fromTo === edge.id; })
                    .sort((a: Models.ILink, b: Models.ILink) => {
                        return (Common.Utils.idFromHref(a.href) < Common.Utils.idFromHref(b.href)) ? -1 : 1;
                    });
                if (this.showIps) {
                    edge.label = '';
                    edge.title = '';
                    for (let i: number = 0; i < actualLinks.length; i++) {
                        edge.label += actualLinks[i].networkInterface.dhcp ? 'auto (DHCP)' : actualLinks[i].networkInterface.ipAddress;
                        edge.label += (i < actualLinks.length - 1) ? '\n' : '';

                        edge.title += actualLinks[i].networkInterface.name + ': ';
                        edge.title += (actualLinks[i].networkInterface.dhcp ? 'auto (DHCP)' : actualLinks[i].networkInterface.ipAddress);
                        edge.title += (i < actualLinks.length - 1 ? '<br>' : '');
                    }
                } else {
                    edge.label = undefined;
                    edge.title = undefined;
                }
                visEdges.update(edge);

                if (link.canWrite === undefined) {
                    this.setPermissionsForLink(link);
                }
            });

            if (this.backendSonElements.links !== undefined) {
                this.setVisSonLinks(visEdges, undefined, firstLoad);
            }
            if (this.selectedElement !== undefined && (this.selectedElement as Models.ILink[]).length > 0 &&
                (this.selectedElement as Models.ILink[])[0].fromTo !== undefined) {
                    this.selectedElementAsLinkArray((this.selectedElement as Models.ILink[])[0].fromTo);
            }
        }

        private setVisSonLinks(visEdges: vis.DataSet, event?: IFlexEvent, firstLoad?: boolean): void {
            for (let networkNode of this.backendNetworkNodes) {
                let index: number = 0;
                const links: ISonLink[] = [];
                if (networkNode.x) {// Node is in the map
                    const nodeHref = "" + networkNode.id;
                    this.backendSonElements.links.forEach((link: ISonLink) => {
                        if (nodeHref === link.sourceHref || nodeHref === link.targetHref) {
                            link.index = index;
                            index++;
                            links.push(link)
                        }
                    });
                    links.forEach((link: ISonLink) => link.total = index - 1);
                }
            }

            this.backendSonElements.links.forEach((link: ISonLink) => {
                this.setVisSonLink(link, event, visEdges, firstLoad);
            });
        }

        private checkSonNodeName(networkNode: Models.INetworkNode, sonNode: Models.ISonNode): boolean {

            if (Common.Utils.idFromHref(networkNode.type.href) === Models.TNS_NETWORK_NODE_TYPE) {
                return networkNode.name === sonNode.name;
            }

            if (!networkNode.blocks) {
                return false;
            }

            const matchingBlocks: Models.IBlock[] = networkNode.blocks
                .filter((block: Models.IBlock) => block.name === sonNode.name);

            return matchingBlocks.length > 0;
        }

        private setVisSonLink(link: ISonLink,
                              event: Application.Models.IFlexEvent,
                              visEdges: vis.DataSet,
                              firstLoad?: boolean): void {
            let fromId: string = Models.SonNode.switchesPreHref + link.source.id;
            let toId: string = Models.SonNode.switchesPreHref + link.target.id;
            const label: string = (link.source.group === 'vport' || link.target.group === 'vport') ? '' :
                link.stats.load !== undefined ? link.stats.load.toFixed(1) + '%' : '';
            if (link.source.group !== 'packet') {
                let nodeFrom: Models.INetworkNode[] = this.backendNetworkNodes.filter((n: Models.INetworkNode) => {
                    // Creates link only if node equals name AND has a nic connected to SON network
                    return this.checkSonNodeName(n, link.source) &&
                        n.networkInterfaces.some((nic: Models.NetworkInterface) =>
                            nic.networkConnectedTo &&
                            nic.networkConnectedTo.type === Models.NetworkType.SON);
                });
                if (nodeFrom && nodeFrom.length > 0) fromId = nodeFrom[0].href;
                else return;
            }

            if (link.target.group !== 'packet') {
                let nodeTo: Models.INetworkNode[] = this.backendNetworkNodes.filter((n: Models.INetworkNode) => {
                    // Creates link only if node equals name AND has a nic connected to SON network
                    return this.checkSonNodeName(n, link.target) &&
                        n.networkInterfaces.some((nic: Models.NetworkInterface) =>
                            nic.networkConnectedTo &&
                            nic.networkConnectedTo.type === Models.NetworkType.SON);
                });
                if (nodeTo && nodeTo.length > 0) toId = nodeTo[0].href;
                else return;
            }

            let width: number;
            switch (link.capacity) {
                case 40000000:
                    width = 5;
                    break;
                case 10000000:
                    width = 4;
                    break;
                case 1000000:
                    width = 2;
                    break;
                default:
                    width = 1;
            }

            const cachedLinkColor: string = this.sonLinkColorCache[link.id];
            let edge: Vis.IEdge = {
                label: label,
                from: fromId,
                to: toId,
                id: link.name,
                width: width,
                font: {
                    align: 'middle',
                },
                color: cachedLinkColor ? cachedLinkColor : 'green',
                dashes: link.vlink,
            };

            let title: string;
            if (link.target.group !== 'vport' && link.source.group !== 'vport') {
                const load = link.stats.load !== undefined ? `${link.stats.load.toFixed(2)} %` : "";
                title = link.name.replace('<->', ' <i class="uk-icon-arrows-h"></i> ')
                    .replace('->', ' <i class="uk-icon-long-arrow-right"></i> ')
                    .replace('<-', ' <i class="uk-icon-long-arrow-left"></i> ');
                title += `<br>
                            <div class="uk-clearfix" style="padding-top: 10px;">
                                <div class="uk-float-left uk-text-bold" style="padding-right: 8px">
                                    Load: <br>
                                    Bitrate: <br>    
                                ID: <br>    
                                </div>
                                <div class="uk-float-left">
                                   ${load}<br>
                                   ${link.stats.bitrate} Mb/s<br>
                                   ${link.id}
                                </div>
                            </div>`;
                edge.title = title;
            }

            // console.log(`Target group for link ${link.name} == ${link.target.group}`);
            if (link.source.group === 'packet' && link.target.group === 'packet') {
                edge.arrows = {to: {enabled: true}};
                edge.smooth = {
                    enabled: true,
                    type: 'curvedCW',
                    roundness: 0.2,
                };
            } else {
                // Disabled because is not working for TNS slots
                if (link.target.group === 'sources') {
                    edge.arrows = {from: {enabled: true}, to: {enabled: false}};
                } else if (link.target.group === 'destinations') {
                    edge.arrows = {to: {enabled: true}, from: {enabled: false}};
                }
            }

            if (link.index !== undefined) {
                const roundness: number = link.total === 0 ? 0 : -0.2 + link.index * 0.4 / link.total;
                edge.smooth = {
                    enabled: true,
                    type: 'curvedCW',
                    roundness: roundness,
                };
            }

            if (event) {
                if (event.component === 'alarms'
                        && event.data.name === 'Link_health'
                        && event.data.deviceId === 'sonLinks/' + link.id) {
                    let color: string = 'green';
                    const severity: number = event.data.level;
                    if (severity !== 4) {
                        color = this.alarmsService.getSeverityColor(severity);
                    }
                    edge.color = color;
                    this.sonLinkColorCache[link.id] = color;
                }
            } else {
                if (firstLoad) {
                    this.setSONLinkColor(link).then((color: string) => {
                        edge.color = color;
                        visEdges.update(edge);
                    }).catch((reason: ngCustom.IReason) => {
                        visEdges.update(edge);
                    });
                }
            }
            visEdges.update(edge);

        }

        private setSONLinkColor(link: ISonLink): ng.IPromise<string> {
            let color: string = 'green';
            let cacheEvents: Models.FlexEvent[] = this.alarmsService.findAlarmByHrefInCache('sonLinks/' + link.id);
            if (cacheEvents && cacheEvents.length > 0) {
                const severity: number = cacheEvents[0].data.level;
                if (severity !== 4) {
                    color = this.alarmsService.getSeverityColor(severity);
                }
                this.sonLinkColorCache[link.id] = color;
                return this.$q.resolve(color);
            } else {
                return this.alarmsService.findEventsForSonLinkId(link.id).then((events: Models.FlexEvent[]) => {
                    if (events.length > 0) {
                        const flexEvent: Models.FlexEvent = events[0];
                        const severity: number = flexEvent.data.level;
                        if (severity !== 4) {
                            color = this.alarmsService.getSeverityColor(severity);
                        }
                        this.sonLinkColorCache[link.id] = color;
                        return color;
                    }
                });
            }
        }

        private clickEvent(data: Vis.IProperties): void {
            this.keepSidebar = false;
            this.$timeout(() => {
                this.closeContextMenu();
                this.toggleNodeInfoSideBar(data);
            });
        }

        private doubleClickEvent(data: Vis.IProperties): void {
            if (data.nodes.length === 1) {
                const networkId: number = Common.Utils.idFromHref(data.nodes[0]);
                this.networkService.getNetworkById(networkId).then((network: Models.Network) => {
                    if (data.nodes[0].indexOf(Models.SonNode.switchesPreHref) > -1) {
                        this.collapseSonNetwork();
                    } else if (data.nodes[0].indexOf('/networks/') > -1 && network.isSon()) {
                        this.expandSonNetwork();
                    }
                });
            }
        }

        private collapseSonNetwork(): void {
            if (!this.backendSonElements || !this.backendSonElements.switches)
                return;

            this.$cookies.remove(NetworkMapController.SON_NETWORK_COOKIE);
            this.backendSonElements.switches.map((s: Models.ISonNode) => {
                (this.visData.nodes as vis.DataSet).remove(s.href);
            });
            this.closeContextMenu();
            // this.closeSidebar();
            this.backendSonElements.showSonCollapsed = true;
            this.setVisNodes();
        }

        private expandSonNetwork( setCookie: boolean = true ): void {
            if (setCookie)
                this.$cookies.put(NetworkMapController.SON_NETWORK_COOKIE, "1");
            for (const network of this.backendNetworks) {
                if (network.isSon()) {
                    // this.selectedElement = undefined;
                    (this.visData.nodes as vis.DataSet).remove(network.href);
                    this.backendSonElements.showSonCollapsed = false;
                    this.setVisNodes();
                }
            }
        }

        private rightClickEvent(data: Vis.IProperties): void {
            this.closeContextMenu();
            data.event.preventDefault();
            let visNodeId: string = this.visNetwork.getNodeAt({x: data.pointer.DOM.x, y: data.pointer.DOM.y});
            let visNode: Vis.INode = (this.visData.nodes as vis.DataSet).get(visNodeId);
            let visEdgeId: string = this.visNetwork.getEdgeAt({x: data.pointer.DOM.x, y: data.pointer.DOM.y});
            let visEdge: Vis.IEdge = (this.visData.edges as vis.DataSet).get(visEdgeId);
            if (visNode && visNodeId && visNodeId.toLowerCase().indexOf('son') === -1) {
                let elementType: TopologyElementType = TopologyElement.getElementTypeByHref(visNode.id);
                let isInternet: boolean = false;
                if (elementType === TopologyElementType.NetworkNode) {
                    this.selectedElement = TopologyElement.findElement(this.backendNetworkNodes as TopologyElement[], visNodeId);
                } else if (elementType === TopologyElementType.Network) {
                    let network: TopologyElement = TopologyElement.findElement(this.backendNetworks as TopologyElement[], visNodeId);
                    if ((network as Models.Network).isInternet()) {
                        isInternet = true;
                    } else {
                        this.selectedElement = network;
                        /*if ((network as Models.Network).isSon())
                            this.toggleNodeInfoSideBar(undefined);*/
                    }
                } else if (elementType === TopologyElementType.Gateway) {
                    this.selectedElement = TopologyElement.findElement(this.backendGateways as TopologyElement[], visNodeId);
                } else if (elementType === TopologyElementType.Probe) {
                    this.selectedElement = TopologyElement.findElement(this.backendProbes as TopologyElement[], visNodeId);
                } else if (elementType === TopologyElementType.Hotspot) {
                    this.selectedElement = TopologyElement.findElement(this.backendHotspots as TopologyElement[], visNodeId);
                } else if (elementType === TopologyElementType.Switch) {
                    this.selectedElement = TopologyElement.findElement(this.backendSonElements.switches as TopologyElement[], visNodeId);
                }
                if (!isInternet) {
                    this.$timeout(() => {
                        this.openContextMenu({x: data.event.clientX, y: data.event.clientY});
                    });
                }
            } else if (visEdge && visEdgeId && visEdgeId.toLowerCase().indexOf('son') === -1) {
                this.selectedElementAsLinkArray(visEdgeId);
                this.$timeout(() => {
                    this.openContextMenu({x: data.event.x, y: data.event.y});
                });
            }
            this.keepSidebar = false;

        }

        private openContextMenu(pPos: Vis.IPosition): void {
            let contextMenu: JQuery = $('#network-context-menu');
            let contextMenuWidth: number = contextMenu.width();
            let contextMenuHeight: number = contextMenu.height();
            let windowWidth: number = $(window).width();
            let windowHeight: number = $(window).height();
            let contextMenuFinalPos: Vis.IPosition = { x: pPos.x, y: pPos.y };

            if (windowWidth - pPos.x < (contextMenuWidth + 5))
                contextMenuFinalPos.x = windowWidth - (contextMenuWidth + 5);
            if (windowHeight - pPos.y < (contextMenuHeight + 5))
                contextMenuFinalPos.y = windowHeight - (contextMenuHeight + 5);

            contextMenu.css({left: contextMenuFinalPos.x, top: contextMenuFinalPos.y, display: 'block'});
        }

        private closeContextMenu(): void {
            let contextMenu: JQuery = $('#network-context-menu');
            contextMenu.css({display: 'none'});
        }

        /**
         *
         * @param x
         * @param y
         * @param id
         * @private
         */
        private getGridPositions(x: number, y: number, id: string): number[] {
            const xCoordinate: number = Common.MathUtils.calculateCoordinate(x);
            const yCoordinate: number = Common.MathUtils.calculateCoordinate(y);

            (this.visData.nodes as vis.DataSet).update({
                id: id,
                x: xCoordinate,
                y: yCoordinate,
            });

            return [xCoordinate, yCoordinate];
        }

        /**
         *
         * @param elementType
         * @private
         */
        private getNodeCollectionTopologyType (elementType: Models.TopologyElementType): ITopologyElement[] {
            let nodeCollection:ITopologyElement[];

            switch (elementType) {
                case Models.TopologyElementType.NetworkNode:
                    nodeCollection = this.backendNetworkNodes;
                    break;
                case Models.TopologyElementType.Network:
                case Models.TopologyElementType.Switch:
                    nodeCollection = this.backendNetworks;
                    break;
                case Models.TopologyElementType.Gateway:
                    nodeCollection = this.backendGateways;
                    break;
                case Models.TopologyElementType.Probe:
                    nodeCollection = this.backendProbes;
                    break;
                case Models.TopologyElementType.Hotspot:
                    nodeCollection = this.backendHotspots;
                    break;
            }
            return nodeCollection;
        }

        /**
         *
         * @param elementHref
         * @param distance
         * @private
         */
        private async updateNode(elementHref:string, distance:Vis.IPosition=undefined) {
            const elementType: Models.TopologyElementType = Models.TopologyElement.getElementTypeByHref(elementHref);
            const currentNodeCollection = this.getNodeCollectionTopologyType(elementType);
            const indexNodeCollection : number = TopologyElement.findIndex(currentNodeCollection as TopologyElement[], elementHref);
            const elementNode = currentNodeCollection[indexNodeCollection];

            if(distance !== undefined){
                elementNode.x += distance.x;
                elementNode.y += distance.y;
            }

            [elementNode.x, elementNode.y] = this.getGridPositions(elementNode.x, elementNode.y, elementHref);

            try {
                const response:any = await this.topologyElementService.placeTopologyElement(currentNodeCollection[indexNodeCollection]);
                if (elementType === Models.TopologyElementType.NetworkNode){
                    let canWrite: boolean = currentNodeCollection[indexNodeCollection].canWrite;
                    currentNodeCollection[indexNodeCollection].canWrite = canWrite;
                } else if (elementType === Models.TopologyElementType.Switch) {
                    this.backendSonElements.sonNetwork = response;
                    this.backendSonElements.center = {x: response.x, y: response.y};
                    this.visNetwork.unselectAll();
                }
                currentNodeCollection[indexNodeCollection] = response;
            } catch (reason) {
                this.messageTranslationsService.showPromiseError(reason);
                this.getAndDrawAllTopologyElements();
            }
        }

        /**
         *
         * @private
         */
        private snapToGrid(): void {
            (this.visData.nodes as vis.DataSet).forEach(async (currentNode: {id: string, x: number, y: number, fixed:boolean}) => {
                if ( !currentNode.fixed ) {
                    const elementHref: string = currentNode.id;
                    await this.updateNode(elementHref);
                }
            });
        }

        /**
         * Fired when the drag has finished.
         * @param {Vis.IProperties} data - An object with structured properties returned by Vis.
         */
        private async dragEndEvent(data: Vis.IProperties) {

            const distance: Vis.IPosition = {
                'x': data.pointer.canvas.x - this.dragStartData.pointer.canvas.x,
                'y': data.pointer.canvas.y - this.dragStartData.pointer.canvas.y,
            };

            for (let i = 0; i < data.nodes.length; ++i) {
                if (data.nodes[i] && (this.visData.nodes as vis.DataSet).get(data.nodes[i]).fixed)
                    return;
                const elementHref: string = data.nodes[i];
                await this.updateNode(elementHref, distance);
            }
        }

        private getNameByHref(href: string): string {
            let elementType: TopologyElementType = Models.TopologyElement.getElementTypeByHref(href);
            let name: string = '';
            if (elementType === TopologyElementType.NetworkNode) {
                this.backendNetworkNodes.forEach((element: Models.INetworkNode) => {
                    if (element.href === href)
                        name = element.name;
                });
            } else if (elementType === TopologyElementType.Network) {
                this.backendNetworks.forEach((element: Models.INetwork) => {
                    if (element.href === href)
                        name = element.name;
                });
            } else if (elementType === TopologyElementType.Gateway) {
                this.backendGateways.forEach((element: Models.IGateway) => {
                    if (element.href === href)
                        name = element.name;
                });
            } else if (elementType === TopologyElementType.Probe) {
                this.backendProbes.forEach((element: Models.IProbe) => {
                    if (element.href === href)
                        name = element.name;
                });
            } else if (elementType === TopologyElementType.Hotspot) {
                this.backendHotspots.forEach((element: Models.IHotspot) => {
                    if (element.href === href)
                        name = element.name;
                });
            }
            return name;
        }

        private toggleNodeInfoSideBar(data: Vis.IProperties): void {
            if (!data || (!data.nodes && !data.edges))
                return;
            if (data.nodes.length === 1) {
                this.oneClickDone = true;
                let elementType: Models.TopologyElementType = Models.TopologyElement.getElementTypeByHref(data.nodes[0]);
                // click on a node
                if (elementType === Models.TopologyElementType.NetworkNode) {
                    let i: number = TopologyElement.findIndex(this.backendNetworkNodes as TopologyElement[], data.nodes[0]);
                    this.selectedElement = this.backendNetworkNodes[i];
                // click on a network
                } else if (elementType === Models.TopologyElementType.Network) {
                    let i: number = TopologyElement.findIndex(this.backendNetworks as TopologyElement[], data.nodes[0]);
                    if (this.backendNetworks[i].isInternet()) {
                        this.visNetwork.unselectAll();
                    } else {
                        this.selectedElement = this.backendNetworks[i];
                    }
                // click on a gateway
                } else if (elementType === Models.TopologyElementType.Gateway) {
                    let i: number = TopologyElement.findIndex(this.backendGateways as TopologyElement[], data.nodes[0]);
                    this.selectedElement = this.backendGateways[i];
                // click on a probe
                } else if (elementType === Models.TopologyElementType.Probe) {
                    let i: number = TopologyElement.findIndex(this.backendProbes as TopologyElement[], data.nodes[0]);
                    this.selectedElement = this.backendProbes[i];
                // click on a hotspot
                } else if (elementType === Models.TopologyElementType.Hotspot) {
                    let i: number = TopologyElement.findIndex(this.backendHotspots as TopologyElement[], data.nodes[0]);
                    this.selectedElement = this.backendHotspots[i];
                // click on a son switch
                } else if (elementType === Models.TopologyElementType.Switch) {
                    let i: number = TopologyElement.findIndex(this.backendSonElements.switches as TopologyElement[], data.nodes[0]);
                    this.selectedElement = this.backendSonElements.switches[i];
                }
            // click on a edge (could represent one or more links)
            } else if (data.edges.length === 1) {
                this.oneClickDone = true;
                let edgeId: string = data.edges[0];
                if (edgeId.indexOf("SON") === -1) {
                    this.selectedElementAsLinkArray(edgeId);
                } else {
                    this.selectedElementAsSonLink(edgeId);
                }
            }
        }

        private selectedElementAsLinkArray(edgeId: string): void {
            if (edgeId.indexOf('MULTIBLOCK') === -1) {
                let selectedLinks: Models.ILink[] = TopologyElement.findLinksByFromToId(this.backendLinks, edgeId);
                if (selectedLinks !== undefined && selectedLinks.length > 0) {
                    this.selectedElement = selectedLinks;
                    this.selectedElement.forEach((link: Models.ILink) => {
                        link.fromName = this.getNameByHref(link.from.href);
                        link.toName = this.getNameByHref(link.to.href);
                    });
                } else {
                    this.selectedElement = undefined;
                }
            } else {
                let selectedMultiBlocks: Models.MultiBlock[] = TopologyElement.findMultiBlocksByFromToId(this.backendMultiblocks, edgeId);
                this.selectedElement = selectedMultiBlocks;
            }

        }

        private selectedElementAsSonLink(edgeId: string): void {
            for (let l of this.backendSonElements.links) {
                if (edgeId === l.fromTo) {
                    this.selectedElement = l;
                    return;
                }
            }
        }

        private openLinkModal(fromHref?: string, toHref?: string): void {
            let network: Models.INetwork;
            let device: Models.ITopologyElement;
            [network, device] = this.openLinkModalHelper(fromHref, toHref);

            this.modalService.showModal({
                templateUrl: Application.Controllers.LinkModalController.templateUrl,
                controller: Application.Controllers.LinkModalController.$name,
                inputs: {
                    title: 'Links',
                    network: network,
                    device: device,
                    addEdgeEvent: !!fromHref,
                },
            }).then((modal: ngModal.IModalObject) => {
                let linkModalElem: UIkit.ModalElement = UIkit.modal(LinkModalController.ID,
                                                                    { bgclose: false, modal: false, keyboard: false });
                linkModalElem.show();
                modal.close.then((result: {device: Models.ITopologyElement, addedLinks: Models.ILink[], removedLinks: Models.ILink[]}) => {
                    linkModalElem.hide();
                    this.visNetwork.enableEditMode();
                    this.edgeMode('none');
                    if (result !== undefined) {
                        if (result.addedLinks !== undefined && result.addedLinks.length > 0) {
                            for (let l of result.addedLinks) {
                                this.topologyElementService.saveTopologyElement(l).then((res: Models.ITopologyElement) => {
                                    this.updateTopologyElement(res);
                                }).catch((reason: ngCustom.IReason) => {
                                    this.modalService.showModal({
                                        templateUrl: Controllers.ErrorModalController.templateURL,
                                        controller: Controllers.ErrorModalController.$name,
                                        inputs: {
                                            title: 'Error creating link',
                                            description: reason.data.message,
                                        },
                                    }).then((modal2: ngModal.IModalObject) => {
                                        let modalElem: UIkit.ModalElement = UIkit.modal(Controllers.ErrorModalController.ID,
                                            {bgclose: false, modal: false, keyboard: false});
                                        modalElem.show();
                                        modal2.close.then((result2: Object) => {
                                            modalElem.hide();
                                        });
                                    });
                                });
                            }
                        }
                        if (result.removedLinks !== undefined && result.removedLinks.length > 0) {
                            for (let l of result.removedLinks) {
                                let i: number;
                                i = TopologyElement.findIndexById(this.backendLinks as TopologyElement[], l.networkInterface.id);
                                if (i !== undefined) {
                                    l.href = this.backendLinks[i].href;
                                    this.topologyElementService.deleteTopologyElement(l).then((res: Models.ITopologyElement) => {
                                        this.deleteTopologyElement(l.networkInterface.id, TopologyElementType.Link);
                                    });
                                }
                            }
                        }
                    }
                });
            });
        }

        private openLinkModalHelper(fromHref?: string, toHref?: string): [Models.INetwork, Models.ITopologyElement] {
            if (!Common.Utils.exists(fromHref)) {
                fromHref = this.selectedElement[0].from.href;
                toHref = this.selectedElement[0].to.href;
            }

            let network: Models.INetwork;
            let device: Models.ITopologyElement;

            let fromType: Models.TopologyElementType = Models.TopologyElement.getElementTypeByHref(fromHref);
            let toType: Models.TopologyElementType = Models.TopologyElement.getElementTypeByHref(toHref);
            if (fromType !== TopologyElementType.Network) {
                [fromHref, toHref] = [toHref, fromHref];
                [fromType, toType] = [toType, fromType];
            }

            network = TopologyElement.findElement(this.backendNetworks as TopologyElement[], fromHref) as Models.Network;

            if (toType === Models.TopologyElementType.Gateway)
                device = TopologyElement.findElement(this.backendGateways as TopologyElement[], toHref);
            else if (toType === Models.TopologyElementType.Hotspot)
                device = TopologyElement.findElement(this.backendHotspots as TopologyElement[], toHref);
            else if (toType === Models.TopologyElementType.NetworkNode)
                device = TopologyElement.findElement(this.backendNetworkNodes as TopologyElement[], toHref);
            else if (toType === Models.TopologyElementType.Probe)
                device = TopologyElement.findElement(this.backendProbes as TopologyElement[], toHref);

            return [network, device];
        }

        private launchNodeModalHelper(element: Models.INetworkNode, step?: number): void {
            let node: Models.INetworkNode = element ? Common.Utils.clone(element) as Models.INetworkNode : Models.NetworkNode.Empty();
            if (node.geoElement === undefined) node.geoElement = new Models.GeoElement();
            if (node.geoElement.auto === undefined) node.geoElement.auto = true;
            if (!node.x || !node.y) {
                [node.x, node.y] = this.topologyElementService.initTopologyCoordinate();
            }
            this.networkNodeTypeService
                .getAllNetworkNodeTypes()
                .then((networkNodeTypes: Models.NetworkNodeType[]) => {
                    this.modalService.showModal({
                        templateUrl: Application.Controllers.NetworkNodeModalController.templateUrl,
                        controller: Application.Controllers.NetworkNodeModalController.$name,
                        inputs: {
                            node: node,
                            nodeTypes: this.networkNodeTypes,
                            gateways: this.backendGateways,
                            mags: this.mags,
                            initialStep: step,
                            internet: this.backendNetworks.filter((value: Models.INetwork) => {
                                return value.isInternet() === true;
                            })[0],
                            deviceGuiUrl: undefined,
                            deviceGuiUrlNoProxy: undefined,
                        },
                    }).then((modal: ngModal.IModalObject) => {
                        let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.NetworkNodeModalController.ID,
                                                                        {bgclose: false, modal: false, keyboard: false});
                        modalElem.show();
                        modal.close.then((result: Models.INetworkNode) => {
                            modalElem.hide();
                            if (result) {
                                this.topologyElementService.getLinkElements().then((links: Models.ILink[]) => {
                                    this.backendLinks = links;
                                    this.updateTopologyElement(result);
                                });
                            }
                        });
                    });
                });
        }

        private zoomToId(simplifiedHref: string): void {
            let found: {id: string, image: string} = this.searchInVis("/" + simplifiedHref);
            if (found) {
                this.visNetwork.focus(found.id, {
                    scale: 1.5,
                    offset: {x: 0, y: 0},
                    locked: false,
                    animation: {
                        duration: 400,
                        easingFunction: "easeInCubic",
                    },
                });
            }
        }

        private searchInVis(simplifiedHref: string): {id: string, image: string} {
            let result: {id: string, image: string}[] = [];
            (this.visData.nodes as vis.DataSet).forEach((n: {id: string, image: string}) => {
                let idFromHref: string = Common.Utils.getSimplifiedHrefFromString(n.id);
                if (idFromHref === simplifiedHref)
                    result.push(n);
            });
            if (result.length > 0)
                return result[0];
            else
                return undefined;
        }

        private storeSonLinkStatsToPlot(i: number, data: ISonLinkStatsToPlot): ISonLinkStatsToPlot {
            let dataLimit: number = 30;
            if (data.load.length > dataLimit) {
                data.load.shift();
                data.bitrate.shift();
            }
            data.load.push(this.backendSonElements.links[i].stats.load);
            data.bitrate.push(this.backendSonElements.links[i].stats.bitrate);
            return data;
        }
    }
}
